import { defineComponent as _defineComponent } from 'vue'
import {
  ref,
  nextTick,
  computed,
  watch,
  onMounted,
  onUnmounted,
  getCurrentInstance,
} from "vue";
import {
  generarTorneo,
  generarPartidosDeZona,
  generarCrucesConByes,
  calcularTablaZona,
  type EstrategiaByes,
} from "../../utils/torneos";
import CargarResultado from "./CargarResultado.vue";
import EditarDetallesPartido from "./EditarDetallesPartido.vue"; // NUEVO IMPORT
import TorneoContextBar from "./TorneoContextBar.vue";
import { showAlert, confirmModal } from "@/utils/toast";
import axios from "@/axios-auth";
import AsignarJugadores from "./AsignarJugadores.vue";
import AsignarNombreEquipo from "./AsignarNombreEquipo.vue";
import ModalFinalizarCompetencia from "./ModalFinalizarCompetencia.vue";
import {
  obtenerJugadoresOrdenadosTorneo,
  puedeFinalizarTorneo,
  type JugadorParaFinalizar,
} from "@/utils/rankings";
import { calcularGanador } from "@/utils/resultados";
import { getConfigDeporte } from "@/utils/deportes-config";


export default /*#__PURE__*/_defineComponent({
  __name: 'Torneos',
  setup(__props) {

const total = ref(8);
const modalidad = ref<"eliminacion_directa" | "zonas_y_eliminacion">(
  "eliminacion_directa",
);
const clasificados = ref<number | undefined>(undefined);
const zonasDeseadas = ref<number | undefined>(undefined);
const estrategiaByes = ref<EstrategiaByes>("orden_zonas");
const nombreTorneo = ref("");
const categoriaTorneo = ref("");
const generoTorneo = ref("");
const tipoCompetenciaTorneo = ref("");
const idTorneo = ref();
const idInstitucion = ref();
const infoTorneo = ref("");
const deporte = ref<"Futbol" | "Padel" | "Tenis">("Padel");

const torneo = ref<any>(null);
const torneoOriginal = ref<any>(null);
const partidoRefs: Record<number, HTMLElement> = {};
const partidoRefsReady = ref(false);
const curves = ref<{ id: string; d: string }[]>([]);
const ignoreNextZonaChange = ref(false); // Nueva bandera

const tab = ref(0);
const zonaTabs = ref<Record<number, number>>({});
const zonaDragOver = ref<number | null>(null);

// Variables para draggable de equipos
const equipoDragging = ref<any>(null);
const partidoDragging = ref<any>(null);
const posicionDragging = ref<"local" | "visitante" | null>(null);
const partidosOriginalesRonda1 = ref<any[]>([]);

const partidosOriginalesPredicciones = ref<any[]>([]);
const partidosOriginalesEstructura = ref<any[]>([]);

const modalResultadoVisible = ref(false);
const modalAsignarJugadoresVisible = ref(false);
const modalAsignarNombreVisible = ref(false);

const partidoActivo = ref<any>(null);
const equipoActivo = ref(null);
const zonaActiva = ref(null);
const sets = ref<Array<{ local: number | null; visitante: number | null }>>([]);
const modalDetallesVisible = ref(false);

const rondasContainer = ref<HTMLElement | null>(null);
const svgWidth = ref(0);
const svgHeight = ref(0);
const calculandoCurvas = ref(false);
const ultimoCalculo = ref(0);

const guardarInterval = ref();

// Nueva variable para controlar edición de predicciones
const habilitarEdicionPredicciones = ref(false);

const modalidades = ref([
  { text: "Eliminación Directa", value: "eliminacion_directa" },
  { text: "Zonas + Eliminación", value: "zonas_y_eliminacion" },
]);

const estrategiasByes = ref([
  { text: "Orden de Zonas", value: "orden_zonas" },
  { text: "Mejor Clasificación", value: "mejor_clasificacion" },
]);

const campeonKey = ref(0);
const estadoKey = ref(0);

// Variables para el drag & drop de equipos entre zonas
const equipoDragData = ref<{
  equipo: any;
  zonaOrigen: any;
} | null>(null);

const estadoTorneo = ref("Draft");

const hayCambiosSinGuardar = ref(false);

const modalFinalizarVisible = ref(false);
const jugadoresFinales = ref<JugadorParaFinalizar[]>([]);

const { proxy } = getCurrentInstance();

const configDeporte = computed(() => getConfigDeporte(deporte.value));
const usaJugadores = computed(() => configDeporte.value.usaJugadores);

const headersPartidos = computed(() => {
  return [
    { text: "Partido", value: "id", sortable: false, width: "80px" },
    { text: "Local", value: "local", sortable: false, width: "25%" },
    { text: "VS", value: "vs", sortable: false },
    { text: "Visitante", value: "visitante", sortable: false, width: "25%" },
    { text: "Detalles", value: "detalles", sortable: false },
    { text: "Resultado", value: "resultado", sortable: false },
    { text: "Estado", value: "estado", sortable: false },
    { text: "Acciones", value: "actions", sortable: false },
  ];
});

// Variables para draggable de predicciones
const prediccionDragging = ref<{
  partido: any;
  posicion: "local" | "visitante";
  valor: string | null;
} | null>(null);

// Mapa para rastrear qué predicción va a qué equipo
const mapaPrediccionesEquipos = ref<Map<string, string>>(new Map());
// Ejemplo: "2º de zona 1" -> "local_P1" (significa que va como local en Partido 1)

function abrirModalDetalles(partido: any) {
  partidoActivo.value = partido;
  modalDetallesVisible.value = true;
}

function closeModalDetalles() {
  modalDetallesVisible.value = false;
  partidoActivo.value = null;
}

function guardarDetalles(detalles: any) {
  if (!partidoActivo.value) return;

  // Asegurar que el objeto detalles exista
  if (!partidoActivo.value.detalles) {
    partidoActivo.value.detalles = {};
  }

  // Actualizar detalles
  partidoActivo.value.detalles = {
    ...partidoActivo.value.detalles,
    ...detalles,
  };

  // Limpiar campos vacíos
  Object.keys(partidoActivo.value.detalles).forEach((key) => {
    if (!partidoActivo.value.detalles[key]) {
      delete partidoActivo.value.detalles[key];
    }
  });

  closeModalDetalles();
}

function reestablecerPrediccionesRondasSiguientes() {
  if (!torneo.value?.rondas || torneo.value.rondas.length <= 1) return;

  // Para cada ronda después de la primera
  for (let i = 1; i < torneo.value.rondas.length; i++) {
    const ronda = torneo.value.rondas[i];
    const rondaAnterior = torneo.value.rondas[i - 1];

    ronda.partidos.forEach((partido: any, index: number) => {
      // Resetear completamente si no tiene equipos reales
      if (
        !partido.local ||
        !partido.visitante ||
        (partido.local && partido.local._temporal) ||
        (partido.visitante && partido.visitante._temporal)
      ) {
        // Solo resetear si no hay equipos reales en ambos lados
        const tieneEquipoRealLocal =
          partido.local &&
          typeof partido.local === "object" &&
          !partido.local._temporal;
        const tieneEquipoRealVisitante =
          partido.visitante &&
          typeof partido.visitante === "object" &&
          !partido.visitante._temporal;

        if (!tieneEquipoRealLocal) {
          partido.local = null;
        }

        if (!tieneEquipoRealVisitante) {
          partido.visitante = null;
        }
      }

      // Mantener la referencia a los partidos de la ronda anterior
      const partidoAnteriorLocal = rondaAnterior.partidos[index * 2];
      const partidoAnteriorVisitante = rondaAnterior.partidos[index * 2 + 1];

      // Establecer referencias
      partido.dePartido = [
        partidoAnteriorLocal?.id,
        partidoAnteriorVisitante?.id,
      ].filter(Boolean);

      // Establecer nombres predictivos solo si no hay equipo real
      if (!partido.local && partidoAnteriorLocal) {
        partido.local = {
          nombre: `Ganador P${partidoAnteriorLocal.id}`,
          // ⭐ SIN flag _temporal
        };
      }

      if (!partido.visitante && partidoAnteriorVisitante) {
        partido.visitante = {
          nombre: `Ganador P${partidoAnteriorVisitante.id}`,
          // ⭐ SIN flag _temporal
        };
      }
    });
  }

  // Forzar actualización de campeón
  campeonKey.value++;
}

// Función para limpiar todos los flags _temporal
function limpiarFlagsTemporales() {
  if (!torneo.value?.rondas) return;

  torneo.value.rondas.forEach((ronda: any) => {
    ronda.partidos.forEach((partido: any) => {
      if (partido.local && partido.local._temporal) {
        delete partido.local._temporal;
      }
      if (partido.visitante && partido.visitante._temporal) {
        delete partido.visitante._temporal;
      }
    });
  });
}

// Función para mover equipo entre zonas
async function moverEquipoEntreZonas(
  zonaOrigen: any,
  zonaDestino: any,
  equipo: any,
) {
  if (estadoTorneo.value === "Publicado") {
    showAlert({
      icon: "warning",
      title:
        "El torneo ya está publicado. Vuelva a ponerlo en estado Draft para mover los equipos.",
      timer: 4000,
      vm: proxy,
    });
    return;
  }

  if (estadoTorneo.value === "Finalizado") {
    showAlert({
      icon: "warning",
      title: "El torneo ya está finalizado. No se pueden mover los equipos.",
      timer: 4000,
      vm: proxy,
    });
    return;
  }

  // Verificar si ya hay resultados en fase eliminatoria
  if (hayResultadosEnFaseEliminacion()) {
    showAlert({
      icon: "warning",
      title:
        "❌ Ya hay partidos jugados en la fase de eliminación.\n\nPara mover equipos entre zonas, primero debe restaurar los cruces usando el botón '↺ Restaurar Cruces Guardados'.",
      timer: 4000,
      vm: proxy,
    });
    return;
  }

  if (todosResultadosZonas.value) {
    showAlert({
      icon: "warning",
      title: "Ya se jugaron todos los partidos de zona.",
      timer: 4000,
      vm: proxy,
    });
    return;
  }

  // Verificar cantidad mínima de equipos
  if (zonaOrigen.equipos.length <= 2) {
    showAlert({
      icon: "warning",
      title: `No se puede mover. La ${zonaOrigen.nombre} necesita al menos 2 equipos.`,
      timer: 4000,
      vm: proxy,
    });
    return;
  }

  const result = await confirmModal({
    vm: proxy,
    title: "Mover equipo.",
    text: "¿Está seguro que desea mover el equipo? Se regenerarán los partidos.",
    icon: "warning",
    showCancelButton: true,
    showCloseButton: true,
  });

  if (!result.isConfirmed) {
    return;
  }

  console.log(
    `Moviendo ${equipo.nombre} de ${zonaOrigen.nombre} a ${zonaDestino.nombre}`,
  );

  // 1. Remover de zona origen
  const equipoIndex = zonaOrigen.equipos.findIndex(
    (e: any) => e.id === equipo.id,
  );
  if (equipoIndex !== -1) {
    zonaOrigen.equipos.splice(equipoIndex, 1);
  }

  // 2. Agregar a zona destino (al final)
  zonaDestino.equipos.push({
    ...equipo,
    // Podrías querer regenerar IDs o mantener el mismo
  });

  // 3. Regenerar partidos en AMBAS zonas
  regenerarPartidosDeZona(zonaOrigen);
  regenerarPartidosDeZona(zonaDestino);
  showAlert({
    icon: "success",
    title: `Equipo "${equipo.nombre}" movido de ${zonaOrigen.nombre} a ${zonaDestino.nombre}.`,
    timer: 2500,
    vm: proxy,
  });
}

// Función para regenerar partidos de una zona
function regenerarPartidosDeZona(zona: any) {
  // Eliminar partidos existentes
  zona.partidos = [];

  // Generar nuevos partidos solo si hay al menos 2 equipos
  if (zona.equipos.length >= 2) {
    zona.partidos = generarPartidosDeZona(zona.equipos, deporte.value);

    // Reasignar IDs
    zona.partidos.forEach((partido: any, index: number) => {
      partido.id = `Z${zona.id}P${index + 1}`;
    });
  }
}

// Función para iniciar drag de predicción
function onPrediccionDragStart(
  event: DragEvent,
  partido: any,
  posicion: "local" | "visitante",
) {
  if (!habilitarEdicionPredicciones.value) {
    event.preventDefault();
    return;
  }

  const valor = posicion === "local" ? partido.local : partido.visitante;
  if (valor === null) return; // No arrastrar BYEs

  prediccionDragging.value = {
    partido,
    posicion,
    valor,
  };

  if (event.dataTransfer) {
    event.dataTransfer.setData("text/plain", valor);
    event.dataTransfer.effectAllowed = "move";
  }
}

function onPrediccionDragOver(event: DragEvent) {
  if (!habilitarEdicionPredicciones.value) return;
  event.preventDefault();
  if (event.dataTransfer) {
    event.dataTransfer.dropEffect = "move";
  }
}

function onPrediccionDrop(
  event: DragEvent,
  partidoDestino: any,
  posicionDestino: "local" | "visitante",
) {
  if (!habilitarEdicionPredicciones.value || !prediccionDragging.value) {
    event.preventDefault();
    return;
  }

  event.preventDefault();

  const {
    partido: partidoOrigen,
    posicion: posicionOrigen,
    valor: valorOrigen,
  } = prediccionDragging.value;

  // No hacer nada si es el mismo lugar
  if (
    partidoOrigen.id === partidoDestino.id &&
    posicionOrigen === posicionDestino
  ) {
    resetPrediccionDrag();
    return;
  }

  // Obtener valor destino
  const valorDestino =
    posicionDestino === "local"
      ? partidoDestino.local
      : partidoDestino.visitante;

  // Si el destino es un BYE (null), no permitir intercambiar
  if (valorDestino === null) {
    showAlert({
      icon: "warning",
      title: "No se puede mover una predicción a una posición con BYE.",
      timer: 4000,
      vm: proxy,
    });
    resetPrediccionDrag();
    return;
  }

  // Realizar intercambio
  intercambiarPredicciones(
    partidoOrigen,
    posicionOrigen,
    partidoDestino,
    posicionDestino,
  );

  // Guardar el mapeo para cuando se asignen equipos reales
  guardarMapeoPredicciones();

  resetPrediccionDrag();
}

// Función para intercambiar predicciones
function intercambiarPredicciones(
  partidoA: any,
  posicionA: "local" | "visitante",
  partidoB: any,
  posicionB: "local" | "visitante",
) {
  const valorA = posicionA === "local" ? partidoA.local : partidoA.visitante;
  const valorB = posicionB === "local" ? partidoB.local : partidoB.visitante;

  console.log(`Intercambiando predicciones:
    ${valorA} (P${partidoA.id}, ${posicionA}) ↔
    ${valorB} (P${partidoB.id}, ${posicionB})`);

  // Intercambiar valores
  if (posicionA === "local") {
    partidoA.local = valorB;
  } else {
    partidoA.visitante = valorB;
  }

  if (posicionB === "local") {
    partidoB.local = valorA;
  } else {
    partidoB.visitante = valorA;
  }

  // Actualizar BYEs si es necesario
  actualizarByesDespuesIntercambio(partidoA);
  actualizarByesDespuesIntercambio(partidoB);

  // Recalcular conexiones
  nextTick(() => {
    calcularCurvas();
  });
}

function actualizarByesDespuesIntercambio(partido: any) {
  partido.pasaAutomatico = partido.local === null || partido.visitante === null;
}

function resetPrediccionDrag() {
  prediccionDragging.value = null;
}

// Guardar mapeo de predicciones a posiciones
function guardarMapeoPredicciones() {
  if (!torneo.value?.rondas[0]?.partidos) return;

  mapaPrediccionesEquipos.value.clear();

  torneo.value.rondas[0].partidos.forEach((partido: any) => {
    if (partido.local && typeof partido.local === "string") {
      const clave = `${partido.local}`;
      const valor = `local_P${partido.id}`;
      mapaPrediccionesEquipos.value.set(clave, valor);
    }

    if (partido.visitante && typeof partido.visitante === "string") {
      const clave = `${partido.visitante}`;
      const valor = `visitante_P${partido.id}`;
      mapaPrediccionesEquipos.value.set(clave, valor);
    }
  });

  console.log(
    "Mapeo de predicciones guardado:",
    Array.from(mapaPrediccionesEquipos.value.entries()),
  );
}

// Nueva función para asignar equipos respetando el mapeo
async function asignarEquiposConMapeo(
  ronda1: any,
  clasificados: any[],
  encontrarEquipo: Function,
) {
  console.log("=== ASIGNANDO EQUIPOS CON MAPEO GUARDADO ===");
  console.log("Clasificados disponibles:", clasificados.length);

  // 1. Primero, resetear todos los partidos de ronda 1
  ronda1.partidos.forEach((partido: any) => {
    partido.local = null;
    partido.visitante = null;
    partido.ganador = null;
    partido.resultado = "";
    partido.pasaAutomatico = false;
    // Inicializar sets vacíos
    if (!partido.sets || partido.sets.length === 0) {
      const minimosRequeridos = deporte.value === "Futbol" ? 1 : 2;
      partido.sets = Array.from({ length: minimosRequeridos }, () => ({
        gamesLocal: null,
        gamesVisitante: null,
      }));
    }
  });

  // 2. Crear un mapa inverso: posición → identificador
  const mapaPosiciones = new Map<string, string>();
  Array.from(mapaPrediccionesEquipos.value.entries()).forEach(
    ([identificador, posicion]) => {
      mapaPosiciones.set(posicion, identificador);
    },
  );

  console.log("Mapa de posiciones:", Array.from(mapaPosiciones.entries()));

  // 3. Recorrer todos los partidos y asignar según el mapeo
  let asignacionesExitosas = 0;
  let asignacionesFallidas = 0;

  ronda1.partidos.forEach((partido: any) => {
    const claveLocal = `local_P${partido.id}`;
    const claveVisitante = `visitante_P${partido.id}`;

    const identificadorLocal = mapaPosiciones.get(claveLocal);
    const identificadorVisitante = mapaPosiciones.get(claveVisitante);

    console.log(`Procesando partido P${partido.id}:`);
    console.log(
      `  - Clave local: ${claveLocal}, Identificador: ${identificadorLocal}`,
    );
    console.log(
      `  - Clave visitante: ${claveVisitante}, Identificador: ${identificadorVisitante}`,
    );

    // Buscar equipos para estos identificadores usando la función encontrarEquipo
    if (identificadorLocal) {
      const equipoLocal = encontrarEquipo(identificadorLocal);
      if (equipoLocal) {
        partido.local = equipoLocal;
        asignacionesExitosas++;
        console.log(
          `✓ Asignado local P${partido.id}: ${identificadorLocal} → ${equipoLocal.nombre}`,
        );
      } else {
        asignacionesFallidas++;
        console.warn(
          `✗ No se encontró equipo para: ${identificadorLocal} (local P${partido.id})`,
        );
        // Intentar buscar en los clasificados directamente
        const equipoEnClasificados = buscarEquipoEnClasificados(
          identificadorLocal,
          clasificados,
        );
        if (equipoEnClasificados) {
          partido.local = equipoEnClasificados;
          console.log(
            `  ✓ Encontrado en clasificados directos: ${equipoEnClasificados.nombre}`,
          );
          asignacionesExitosas++;
          asignacionesFallidas--;
        }
      }
    }

    if (identificadorVisitante) {
      const equipoVisitante = encontrarEquipo(identificadorVisitante);
      if (equipoVisitante) {
        partido.visitante = equipoVisitante;
        asignacionesExitosas++;
        console.log(
          `✓ Asignado visitante P${partido.id}: ${identificadorVisitante} → ${equipoVisitante.nombre}`,
        );
      } else {
        asignacionesFallidas++;
        console.warn(
          `✗ No se encontró equipo para: ${identificadorVisitante} (visitante P${partido.id})`,
        );
        // Intentar buscar en los clasificados directamente
        const equipoEnClasificados = buscarEquipoEnClasificados(
          identificadorVisitante,
          clasificados,
        );
        if (equipoEnClasificados) {
          partido.visitante = equipoEnClasificados;
          console.log(
            `  ✓ Encontrado en clasificados directos: ${equipoEnClasificados.nombre}`,
          );
          asignacionesExitosas++;
          asignacionesFallidas--;
        }
      }
    }

    // Actualizar estado de BYE (solo si hay exactamente un equipo)
    partido.pasaAutomatico =
      (partido.local && !partido.visitante) ||
      (!partido.local && partido.visitante);

    // Si es BYE, asignar ganador automático
    if (partido.pasaAutomatico) {
      if (partido.local && !partido.visitante) {
        partido.ganador = partido.local;
        partido.resultado = `BYE (avanza ${partido.local.nombre})`;
        actualizarSiguienteRonda(partido);
      } else if (!partido.local && partido.visitante) {
        partido.ganador = partido.visitante;
        partido.resultado = `BYE (avanza ${partido.visitante.nombre})`;
        actualizarSiguienteRonda(partido);
      }
    }

    console.log(
      `  Resultado final: ${partido.local?.nombre || "—"} vs ${
        partido.visitante?.nombre || "—"
      }`,
    );
  });

  console.log(`=== FIN ASIGNACIÓN CON MAPEO ===`);
  console.log(
    `Asignaciones exitosas: ${asignacionesExitosas}, Fallidas: ${asignacionesFallidas}`,
  );
}

// Función auxiliar para buscar equipo en clasificados directamente
function buscarEquipoEnClasificados(
  identificador: string,
  clasificados: any[],
) {
  // Intentar diferentes patrones
  const patrones = [
    /(\d+)º de zona (\d+)/,
    /(\d+)º mejor de zona (\d+)/,
    /Mejor (\d+)º/,
    /(\d+)º mejor (\d+)º/,
  ];

  for (const patron of patrones) {
    const match = identificador.match(patron);
    if (match) {
      if (patron.toString().includes("zona")) {
        // Patrón con zona
        const nivel = parseInt(match[1]);
        const zona = parseInt(match[2]);

        return clasificados.find(
          (c: any) =>
            c._meta && c._meta.zona === zona && c._meta.nivel === nivel,
        );
      } else if (patron.toString().includes("Mejor")) {
        // Patrón de "Mejor Xº"
        const nivel = parseInt(match[1] || "2"); // Default a 2 si no hay número

        // Buscar el mejor equipo de ese nivel
        const equiposNivel = clasificados
          .filter((c: any) => c._meta && c._meta.nivel === nivel)
          .sort((a: any, b: any) => {
            if (b._meta.puntos !== a._meta.puntos)
              return b._meta.puntos - a._meta.puntos;
            if (b._meta.setsDiff !== a._meta.setsDiff)
              return b._meta.setsDiff - a._meta.setsDiff;
            return b._meta.gamesDiff - a._meta.gamesDiff;
          });

        return equiposNivel.length > 0 ? equiposNivel[0] : null;
      }
    }
  }

  return null;
}

// Función original de asignación (para cuando no hay mapeo)
async function asignarEquiposOriginal(
  ronda1: any,
  clasificados: any[],
  prediccionOriginal: any,
  encontrarEquipo: Function,
) {
  console.log("=== ASIGNANDO EQUIPOS CON PREDICCIÓN ORIGINAL ===");
  console.log("Clasificados disponibles:", clasificados.length);
  console.log("Predicción original:", prediccionOriginal);

  const mapaEquipos = new Map<string, any>();
  const identificadoresUnicos: string[] = [];

  // Extraer todos los identificadores únicos de la predicción
  prediccionOriginal.enfrentamientos.forEach((partido: any) => {
    if (
      partido.local &&
      typeof partido.local === "string" &&
      !mapaEquipos.has(partido.local)
    ) {
      identificadoresUnicos.push(partido.local);
    }
    if (
      partido.visitante &&
      typeof partido.visitante === "string" &&
      !mapaEquipos.has(partido.visitante)
    ) {
      identificadoresUnicos.push(partido.visitante);
    }
  });

  console.log("Identificadores a mapear:", identificadoresUnicos);

  // Mapear cada identificador a un equipo real
  identificadoresUnicos.forEach((identificador) => {
    const equipo = encontrarEquipo(identificador);
    if (equipo) {
      mapaEquipos.set(identificador, equipo);
      console.log(`✓ Mapeado: "${identificador}" -> ${equipo.nombre}`);
    } else {
      console.warn(`✗ No se encontró equipo para: "${identificador}"`);
      // Intentar buscar directamente en clasificados
      const equipoDirecto = buscarEquipoEnClasificados(
        identificador,
        clasificados,
      );
      if (equipoDirecto) {
        mapaEquipos.set(identificador, equipoDirecto);
        console.log(`  ✓ Encontrado directamente: ${equipoDirecto.nombre}`);
      }
    }
  });

  // Resetear partidos
  ronda1.partidos.forEach((partido: any) => {
    partido.local = null;
    partido.visitante = null;
    partido.ganador = null;
    partido.resultado = "";
    partido.pasaAutomatico = false;
    // Inicializar sets vacíos
    if (!partido.sets || partido.sets.length === 0) {
      const minimosRequeridos = deporte.value === "Futbol" ? 1 : 2;
      partido.sets = Array.from({ length: minimosRequeridos }, () => ({
        gamesLocal: null,
        gamesVisitante: null,
      }));
    }
  });

  // Asignar según predicción
  let asignacionesExitosas = 0;
  let asignacionesFallidas = 0;

  prediccionOriginal.enfrentamientos.forEach(
    (partidoPredicho: any, index: number) => {
      const partidoReal = ronda1.partidos[index];
      if (!partidoReal) return;

      // Buscar equipos reales en el mapa
      const localReal = partidoPredicho.local
        ? mapaEquipos.get(partidoPredicho.local as string) || null
        : null;
      const visitanteReal = partidoPredicho.visitante
        ? mapaEquipos.get(partidoPredicho.visitante as string) || null
        : null;

      // Solo asignar si encontramos equipos
      if (localReal && typeof localReal === "object") {
        partidoReal.local = localReal;
        asignacionesExitosas++;
      }
      if (visitanteReal && typeof visitanteReal === "object") {
        partidoReal.visitante = visitanteReal;
        asignacionesExitosas++;
      }

      partidoReal.pasaAutomatico = partidoPredicho.pasaAutomatico;

      console.log(
        `Partido ${index + 1}: ${
          localReal?.nombre || partidoPredicho.local || "—"
        } vs ${visitanteReal?.nombre || partidoPredicho.visitante || "—"} ${
          partidoReal.pasaAutomatico ? "(BYE)" : ""
        }`,
      );

      // Contar asignaciones fallidas
      if (
        partidoPredicho.local &&
        typeof partidoPredicho.local === "string" &&
        !localReal
      ) {
        asignacionesFallidas++;
        console.warn(`  ✗ No se pudo asignar: ${partidoPredicho.local}`);
      }
      if (
        partidoPredicho.visitante &&
        typeof partidoPredicho.visitante === "string" &&
        !visitanteReal
      ) {
        asignacionesFallidas++;
        console.warn(`  ✗ No se pudo asignar: ${partidoPredicho.visitante}`);
      }

      // BYEs automáticos
      if (partidoReal.pasaAutomatico) {
        if (localReal && !visitanteReal) {
          partidoReal.ganador = localReal;
          partidoReal.resultado = `BYE (avanza ${localReal.nombre})`;
          actualizarSiguienteRonda(partidoReal);
        } else if (!localReal && visitanteReal) {
          partidoReal.ganador = visitanteReal;
          partidoReal.resultado = `BYE (avanza ${visitanteReal.nombre})`;
          actualizarSiguienteRonda(partidoReal);
        }
      }
    },
  );

  console.log("=== FIN ASIGNACIÓN ORIGINAL ===");
  console.log(
    `Asignaciones exitosas: ${asignacionesExitosas}, Fallidas: ${asignacionesFallidas}`,
  );
}

// Guardar mapeo cuando se generan los cruces iniciales
watch(
  () => torneo.value?.rondas?.[0]?.partidos,
  (nuevosPartidos) => {
    if (nuevosPartidos && !todosResultadosZonas.value) {
      // Guardar mapeo inicial
      guardarMapeoPredicciones();
    }
  },
  { deep: true },
);

// También guardar mapeo cuando se editan predicciones
watch(
  () => habilitarEdicionPredicciones.value,
  (editando) => {
    if (!editando) {
      // Al salir del modo edición, guardar el mapeo final
      guardarMapeoPredicciones();
    }
  },
);

function onEquipoDragStart(
  event: DragEvent,
  equipo: any,
  partido: any,
  posicion: "local" | "visitante",
) {
  if (!equipo || partido.ganador || partido.pasaAutomatico) {
    event.preventDefault();
    return;
  }

  equipoDragging.value = equipo;
  partidoDragging.value = partido;
  posicionDragging.value = posicion;

  if (event.dataTransfer) {
    event.dataTransfer.setData("text/plain", equipo.id);
    event.dataTransfer.effectAllowed = "move";
  }
}

// Función cuando empieza a arrastrar un equipo DESDE UNA ZONA
function onEquipoDragStartZona(event: DragEvent, equipo: any, zonaOrigen: any) {
  equipoDragData.value = {
    equipo,
    zonaOrigen,
    origen: "zona", // ← IMPORTANTE: identificar que viene de una zona
  };

  if (event.dataTransfer) {
    event.dataTransfer.setData("text/plain", `zona-${equipo.id}`);
    event.dataTransfer.effectAllowed = "move";
  }

  // Feedback visual
  const target = event.target as HTMLElement;
  target.classList.add("dragging");
}

// Función cuando un equipo se arrastra sobre una zona
function onZonaDragOver(event: DragEvent) {
  event.preventDefault();
  if (event.dataTransfer) {
    event.dataTransfer.dropEffect = "move";
  }

  // Feedback visual
  const target = event.currentTarget as HTMLElement;
  target.classList.add("drag-over-zone");
}

function onZonaDragLeave(event: DragEvent) {
  const target = event.currentTarget as HTMLElement;
  target.classList.remove("drag-over-zone");
}

// Función cuando se suelta un equipo en una zona
function onZonaDrop(event: DragEvent, zonaDestino: any) {
  event.preventDefault();

  if (!equipoDragData.value || equipoDragData.value.origen !== "zona") {
    limpiarFeedbackDrag();
    return;
  }

  const { equipo, zonaOrigen } = equipoDragData.value;

  // Limpiar feedback visual
  limpiarFeedbackDrag();

  // Evitar mover a la misma zona
  if (zonaOrigen.id === zonaDestino.id) {
    equipoDragData.value = null;
    return;
  }

  // Mover equipo de zona origen a zona destino
  moverEquipoEntreZonas(zonaOrigen, zonaDestino, equipo);

  equipoDragData.value = null;
}

// Función para limpiar feedback visual
function limpiarFeedbackDrag() {
  document.querySelectorAll(".dragging, .drag-over-zone").forEach((el) => {
    el.classList.remove("dragging", "drag-over-zone");
  });
}

// Función cuando termina el drag
function onEquipoDragEnd() {
  limpiarFeedbackDrag();
  equipoDragData.value = null;
}

function onEquipoDragOver(event: DragEvent) {
  event.preventDefault();
  if (event.dataTransfer) {
    event.dataTransfer.dropEffect = "move";
  }

  // Agregar clase visual para feedback
  const target = event.target as HTMLElement;
  if (target.classList.contains("equipo-draggable")) {
    target.classList.add("drag-over");
  }
}

function onEquipoDragLeave(event: DragEvent) {
  const target = event.target as HTMLElement;
  if (target.classList.contains("equipo-draggable")) {
    target.classList.remove("drag-over");
  }
}

function onEquipoDrop(
  event: DragEvent,
  partidoDestino: any,
  posicionDestino: "local" | "visitante",
) {
  event.preventDefault();

  // Limpiar clases visuales
  const target = event.target as HTMLElement;
  if (target.classList.contains("equipo-draggable")) {
    target.classList.remove("drag-over");
  }

  // Validaciones
  if (!equipoDragging.value || !partidoDragging.value) {
    resetDragData();
    return;
  }

  // No intercambiar con el mismo partido/posición
  if (
    partidoDragging.value.id === partidoDestino.id &&
    posicionDragging.value === posicionDestino
  ) {
    resetDragData();
    return;
  }

  // Obtener equipo destino
  const equipoDestino =
    posicionDestino === "local"
      ? partidoDestino.local
      : partidoDestino.visitante;

  // Realizar intercambio
  intercambiarEquipos(
    partidoDragging.value,
    posicionDragging.value!,
    equipoDragging.value,
    partidoDestino,
    posicionDestino,
    equipoDestino,
  );

  if (
    partidoDragging.value.ganador ||
    partidoDragging.value.pasaAutomatico ||
    partidoDestino.ganador ||
    partidoDestino.pasaAutomatico
  ) {
    console.log("partidos", partidoDestino, partidoDragging);
    actualizarSiguienteRonda({
      ...partidoDestino,
      ganador: partidoDestino.local,
    });
  }

  resetDragData();
}

function intercambiarEquipos(
  partidoA: any,
  posicionA: "local" | "visitante",
  equipoA: any,
  partidoB: any,
  posicionB: "local" | "visitante",
  equipoB: any,
) {
  console.log(`Intercambiando:
    Partido ${partidoA.id} (${posicionA}): ${equipoA?.nombre}
    Partido ${partidoB.id} (${posicionB}): ${equipoB?.nombre || "Vacío"}`);

  // Guardar posiciones originales para animación
  const posOriginalA = {
    x: partidoRefs[partidoA.id]?.offsetLeft || 0,
    y: partidoRefs[partidoA.id]?.offsetTop || 0,
  };

  const posOriginalB = {
    x: partidoRefs[partidoB.id]?.offsetLeft || 0,
    y: partidoRefs[partidoB.id]?.offsetTop || 0,
  };

  // Realizar intercambio
  if (posicionA === "local") {
    partidoA.local = equipoB;
  } else {
    partidoA.visitante = equipoB;
  }

  if (posicionB === "local") {
    partidoB.local = equipoA;
  } else {
    partidoB.visitante = equipoA;
  }

  // Limpiar resultados de ambos partidos
  limpiarResultadoPartido(partidoA);
  limpiarResultadoPartido(partidoB);

  console.log("Intercambio completado");

  // ⚡ FORZAR actualización del DOM y recalcular conexiones
  recalcularTodasLasConexiones();
}

async function toggleEdicionPredicciones() {
  if (estadoTorneo.value === "Publicado") {
    showAlert({
      icon: "warning",
      title:
        "El torneo ya está publicado. Vuelva a ponerlo en estado Draft para editar los cruces.",
      timer: 5000,
      vm: proxy,
    });
    return;
  }
  const estabaEditando = habilitarEdicionPredicciones.value;
  habilitarEdicionPredicciones.value = !habilitarEdicionPredicciones.value;

  // Si ESTÁBAMOS editando y ahora FINALIZAMOS
  if (estabaEditando) {
    console.log("🔚 Finalizando edición, reasignando refs...");

    // 1. Guardar el mapeo de predicciones
    guardarMapeoPredicciones();

    // 2. Forzar actualización del DOM
    await nextTick();

    // 3. Resetear y reasignar TODOS los refs
    await resetearYReasignarRefs();

    // 4. Recalcular conexiones
    recalcularTodasLasConexiones();

    console.log("✅ Edición finalizada, refs reasignados");
  }
}

// NUEVA FUNCIÓN: Resetear y reasignar refs
async function resetearYReasignarRefs() {
  // 1. Limpiar todos los refs existentes
  Object.keys(partidoRefs).forEach((key: any) => {
    delete partidoRefs[key];
  });

  // 2. Esperar a que Vue actualice el DOM
  await nextTick();
  await new Promise((resolve) => setTimeout(resolve, 100)); // Delay extra

  // 3. Marcar que los refs no están listos
  partidoRefsReady.value = false;

  // 4. Forzar un nuevo ciclo de renderizado
  await nextTick();
  await nextTick(); // Doble nextTick para asegurar

  // 5. Los refs se reasignarán automáticamente en el template
  partidoRefsReady.value = true;
}

// NUEVA FUNCIÓN: Recalcular todas las conexiones
function recalcularTodasLasConexiones() {
  // Esperar a que Vue actualice el DOM
  nextTick(() => {
    // Pequeño delay para asegurar que el DOM esté actualizado
    setTimeout(() => {
      calcularCurvas();
      partidoRefsReady.value = true;
    }, 100);
  });
}

function limpiarResultadoPartido(partido: any) {
  partido.ganador = null;
  partido.resultado = "";

  // ✅ CREAR ESTRUCTURA CORRECTA SEGÚN DEPORTE
  const minimosRequeridos = deporte.value === "Futbol" ? 1 : 2;

  if (!partido.sets || partido.sets.length === 0) {
    partido.sets = Array.from({ length: minimosRequeridos }, () => ({
      gamesLocal: null,
      gamesVisitante: null,
    }));
  } else {
    // Ajustar cantidad de sets si es necesario
    if (partido.sets.length !== minimosRequeridos) {
      partido.sets = Array.from({ length: minimosRequeridos }, () => ({
        gamesLocal: null,
        gamesVisitante: null,
      }));
    } else {
      // Solo limpiar los valores, mantener la cantidad
      partido.sets.forEach((set: any) => {
        set.gamesLocal = null;
        set.gamesVisitante = null;
      });
    }
  }
}

function resetDragData() {
  equipoDragging.value = null;
  partidoDragging.value = null;
  posicionDragging.value = null;
}

// Función para obtener posición del equipo
function obtenerPosicionEquipo(equipo: any): string {
  if (!equipo?._meta) return "";
  return `${equipo._meta.nivel}º Z${equipo._meta.zona}`;
}

async function resetearCruces() {
  // Si no hay partidos originales guardados, intentar usar los actuales
  if (estadoTorneo.value === "Finalizado") {
    showAlert({
      icon: "warning",
      title: "El torneo ya está finalizado. No se pueden resetear los cruces.",
      timer: 4000,
      vm: proxy,
    });
    return;
  }

  if (partidosOriginalesRonda1.value.length === 0) {
    if (torneo.value?.rondas?.[0]?.partidos) {
      // Guardar los partidos actuales como originales (pero sin resultados)
      partidosOriginalesRonda1.value = JSON.parse(
        JSON.stringify(torneo.value.rondas[0].partidos),
      ).map((partido: any) => ({
        id: partido.id,
        local: partido.local,
        visitante: partido.visitante,
        pasaAutomatico: partido.pasaAutomatico || false,
        // No guardamos ganador, resultado ni sets
      }));
      console.log(
        "Partidos actuales guardados como originales (sin resultados)",
      );
    } else {
      showAlert({
        icon: "warning",
        title: "No hay configuración de cruces disponible.",
        timer: 4000,
        vm: proxy,
      });
      return;
    }
  }

  // Obtener clasificados actuales
  const clasificados = obtenerClasificados();

  if (clasificados.length === 0) {
    showAlert({
      icon: "warning",
      title:
        "No hay equipos clasificados disponibles. Primero cargue resultados de zonas.",
      timer: 4000,
      vm: proxy,
    });
    return;
  }

  const result = await confirmModal({
    vm: proxy,
    title: "Restaurar cruces.",
    text: "¿Está seguro que desea restaurar los cruces? Se regenerarán los partidos de la fase de eliminación.",
    icon: "warning",
    showCancelButton: true,
    showCloseButton: true,
  });

  if (!result.isConfirmed) {
    return;
  }

  console.log("Clasificados disponibles para resetear:", clasificados.length);
  console.log("Tamaño mapa predicciones:", mapaPrediccionesEquipos.value.size);

  // **PASO CRÍTICO: LIMPIAR COMPLETAMENTE TODAS LAS RONDAS**
  console.log("Limpiando resultados de TODAS las rondas...");

  // Limpiar todas las rondas
  torneo.value.rondas.forEach((ronda: any, rondaIndex: number) => {
    console.log(`Limpiando ronda ${rondaIndex + 1}...`);

    ronda.partidos.forEach((partido: any) => {
      // Resetear completamente los resultados
      partido.ganador = null;
      partido.resultado = "";

      // Resetear sets
      if (!partido.sets || partido.sets.length === 0) {
        // ✅ CREAR SETS DINÁMICAMENTE SEGÚN DEPORTE
        const minimosRequeridos = deporte.value === "Futbol" ? 1 : 2;
        partido.sets = Array.from({ length: minimosRequeridos }, () => ({
          gamesLocal: null,
          gamesVisitante: null,
        }));
      } else {
        partido.sets.forEach((set: any) => {
          set.gamesLocal = null;
          set.gamesVisitante = null;
        });
      }

      // **SOLO PARA RONDAS DESPUÉS DE LA PRIMERA: Resetear también los equipos**
      if (rondaIndex > 0) {
        partido.local = null;
        partido.visitante = null;

        // **IMPORTANTE: Mantener las referencias dePartido para reconstrucción**
        // Las referencias dePartido (localPartido, visitantePartido) deben mantenerse
        // para que el sistema sepa cómo reconstruir los enfrentamientos
      }
    });
  });

  // DECISIÓN CRÍTICA: ¿Qué restaurar?
  // Opción A: Si hay ediciones en el mapa, usarlas
  // Opción B: Si no hay ediciones, usar los originales

  const ronda1 = torneo.value.rondas[0];

  if (mapaPrediccionesEquipos.value.size > 0) {
    console.log("Restaurando usando MAPA DE PREDICCIONES EDITADO");
    // USAR LAS PREDICCIONES EDITADAS

    // **CORRECIÓN: Primero limpiar completamente los equipos de la ronda 1**
    ronda1.partidos.forEach((partido: any) => {
      partido.local = null;
      partido.visitante = null;
      partido.pasaAutomatico = false;
    });

    // Ahora asignar usando el mapa de predicciones EDITADO
    // 1. Crear mapa inverso: posición → identificador
    const mapaPosiciones = new Map<string, string>();
    Array.from(mapaPrediccionesEquipos.value.entries()).forEach(
      ([identificador, posicion]) => {
        mapaPosiciones.set(posicion, identificador);
      },
    );

    console.log(
      "Mapa de posiciones editado:",
      Array.from(mapaPosiciones.entries()),
    );

    // Función para encontrar equipo
    const encontrarEquipo = (identificador: string) => {
      if (!identificador || typeof identificador !== "string") return null;

      // Patrones comunes
      const matchZona = identificador.match(/(\d+)º de zona (\d+)/);
      if (matchZona) {
        const nivel = parseInt(matchZona[1]);
        const zona = parseInt(matchZona[2]);

        return clasificados.find(
          (c) => c._meta && c._meta.zona === zona && c._meta.nivel === nivel,
        );
      }

      const matchMejorDeZona = identificador.match(
        /(\d+)º mejor de zona (\d+)/,
      );
      if (matchMejorDeZona) {
        const nivel = parseInt(matchMejorDeZona[1]);
        const zona = parseInt(matchMejorDeZona[2]);

        return clasificados.find(
          (c) => c._meta && c._meta.zona === zona && c._meta.nivel === nivel,
        );
      }

      return buscarEquipoEnClasificados(identificador, clasificados);
    };

    // 2. Asignar equipos según el mapa EDITADO
    ronda1.partidos.forEach((partido: any) => {
      const claveLocal = `local_P${partido.id}`;
      const claveVisitante = `visitante_P${partido.id}`;

      const identificadorLocal = mapaPosiciones.get(claveLocal);
      const identificadorVisitante = mapaPosiciones.get(claveVisitante);

      if (identificadorLocal) {
        const equipoLocal = encontrarEquipo(identificadorLocal);
        if (equipoLocal) {
          partido.local = equipoLocal;
          console.log(
            `✓ Asignado local P${partido.id}: ${identificadorLocal} → ${equipoLocal.nombre}`,
          );
        } else {
          console.warn(
            `✗ No se encontró equipo para: ${identificadorLocal} (local P${partido.id})`,
          );
        }
      }

      if (identificadorVisitante) {
        const equipoVisitante = encontrarEquipo(identificadorVisitante);
        if (equipoVisitante) {
          partido.visitante = equipoVisitante;
          console.log(
            `✓ Asignado visitante P${partido.id}: ${identificadorVisitante} → ${equipoVisitante.nombre}`,
          );
        } else {
          console.warn(
            `✗ No se encontró equipo para: ${identificadorVisitante} (visitante P${partido.id})`,
          );
        }
      }

      // Actualizar BYEs
      partido.pasaAutomatico =
        partido.local === null || partido.visitante === null;

      // **CORRECIÓN: Solo establecer BYE si realmente falta un equipo**
      if (partido.pasaAutomatico) {
        if (partido.local && !partido.visitante) {
          partido.ganador = partido.local;
          partido.resultado = `BYE (avanza ${partido.local.nombre})`;
          actualizarSiguienteRonda(partido);
        } else if (!partido.local && partido.visitante) {
          partido.ganador = partido.visitante;
          partido.resultado = `BYE (avanza ${partido.visitante.nombre})`;
          actualizarSiguienteRonda(partido);
        }
      } else {
        // Si tiene ambos equipos, asegurarse de limpiar BYE anterior
        partido.ganador = null;
        partido.resultado = "";
      }
    });
  } else {
    console.log("Restaurando usando CRUCES ORIGINALES (sin ediciones)");
    // USAR LOS CRUCES ORIGINALES SIN EDITAR

    // Verificar si los partidos originales tienen equipos reales o predicciones
    const tieneEquiposReales = partidosOriginalesRonda1.value.some(
      (p: any) => p.local && typeof p.local === "object",
    );

    if (tieneEquiposReales) {
      console.log(
        "Los partidos originales ya tienen equipos reales, restaurando estructura...",
      );

      // **CORRECIÓN: No restaurar directamente, sino reasignar equipos actuales**
      ronda1.partidos.forEach((partidoReal: any, index: number) => {
        const partidoOriginal = partidosOriginalesRonda1.value[index];
        if (!partidoOriginal) return;

        // Mantener la estructura pero limpiar resultados
        partidoReal.local = null;
        partidoReal.visitante = null;
        partidoReal.pasaAutomatico = partidoOriginal.pasaAutomatico || false;

        // Solo asignar equipos si existen en los clasificados actuales
        if (
          partidoOriginal.local &&
          typeof partidoOriginal.local === "object"
        ) {
          const equipoEncontrado = clasificados.find(
            (c) => c.id === partidoOriginal.local.id,
          );
          if (equipoEncontrado) {
            partidoReal.local = equipoEncontrado;
          }
        }

        if (
          partidoOriginal.visitante &&
          typeof partidoOriginal.visitante === "object"
        ) {
          const equipoEncontrado = clasificados.find(
            (c) => c.id === partidoOriginal.visitante.id,
          );
          if (equipoEncontrado) {
            partidoReal.visitante = equipoEncontrado;
          }
        }
      });
    } else {
      console.log(
        "Los partidos originales tienen predicciones, reasignando equipos...",
      );

      // **CORRECIÓN: Primero limpiar completamente**
      ronda1.partidos.forEach((partido: any) => {
        partido.local = null;
        partido.visitante = null;
        partido.ganador = null;
        partido.resultado = "";
        partido.pasaAutomatico = false;
        if (!partido.sets || partido.sets.length === 0) {
          // ✅ CREAR SETS DINÁMICAMENTE SEGÚN DEPORTE
          const minimosRequeridos = deporte.value === "Futbol" ? 1 : 2;
          partido.sets = Array.from({ length: minimosRequeridos }, () => ({
            gamesLocal: null,
            gamesVisitante: null,
          }));
        }
      });

      // Crear predicción original
      const prediccionOriginal = {
        enfrentamientos: partidosOriginalesRonda1.value.map((partido: any) => ({
          local: partido.local,
          visitante: partido.visitante,
          pasaAutomatico: partido.pasaAutomatico,
        })),
      };

      // Función para encontrar equipo
      const encontrarEquipo = (identificador: string) => {
        if (!identificador || typeof identificador !== "string") return null;

        // Patrones comunes
        const matchZona = identificador.match(/(\d+)º de zona (\d+)/);
        if (matchZona) {
          const nivel = parseInt(matchZona[1]);
          const zona = parseInt(matchZona[2]);

          return clasificados.find(
            (c) => c._meta && c._meta.zona === zona && c._meta.nivel === nivel,
          );
        }

        const matchMejorDeZona = identificador.match(
          /(\d+)º mejor de zona (\d+)/,
        );
        if (matchMejorDeZona) {
          const nivel = parseInt(matchMejorDeZona[1]);
          const zona = parseInt(matchMejorDeZona[2]);

          return clasificados.find(
            (c) => c._meta && c._meta.zona === zona && c._meta.nivel === nivel,
          );
        }

        return buscarEquipoEnClasificados(identificador, clasificados);
      };

      // Reasignar equipos usando la lógica de asignarEquiposOriginal
      prediccionOriginal.enfrentamientos.forEach(
        (partidoPredicho: any, index: number) => {
          const partidoReal = ronda1.partidos[index];
          if (!partidoReal) return;

          const localReal = partidoPredicho.local
            ? encontrarEquipo(partidoPredicho.local as string) || null
            : null;
          const visitanteReal = partidoPredicho.visitante
            ? encontrarEquipo(partidoPredicho.visitante as string) || null
            : null;

          if (localReal && typeof localReal === "object") {
            partidoReal.local = localReal;
          }
          if (visitanteReal && typeof visitanteReal === "object") {
            partidoReal.visitante = visitanteReal;
          }

          partidoReal.pasaAutomatico = partidoPredicho.pasaAutomatico;

          // BYEs automáticos
          if (partidoReal.pasaAutomatico) {
            if (localReal && !visitanteReal) {
              partidoReal.ganador = localReal;
              partidoReal.resultado = `BYE (avanza ${localReal.nombre})`;
              actualizarSiguienteRonda(partidoReal);
            } else if (!localReal && visitanteReal) {
              partidoReal.ganador = visitanteReal;
              partidoReal.resultado = `BYE (avanza ${visitanteReal.nombre})`;
              actualizarSiguienteRonda(partidoReal);
            }
          } else {
            // Limpiar BYE anterior si ahora tiene ambos equipos
            partidoReal.ganador = null;
            partidoReal.resultado = "";
          }
        },
      );
    }
  }

  // **CORRECIÓN ADICIONAL: Limpiar sets de todos los partidos**
  torneo.value.rondas.forEach((ronda: any) => {
    ronda.partidos.forEach((partido: any) => {
      if (!partido.sets || partido.sets.length === 0) {
        // ✅ CREAR SETS DINÁMICAMENTE SEGÚN DEPORTE
        const minimosRequeridos = deporte.value === "Futbol" ? 1 : 2;
        partido.sets = Array.from({ length: minimosRequeridos }, () => ({
          gamesLocal: null,
          gamesVisitante: null,
        }));
      } else {
        // Limpiar los sets existentes
        partido.sets.forEach((set: any) => {
          set.gamesLocal = null;
          set.gamesVisitante = null;
        });
      }
    });
  });

  // REESTABLECER LAS PREDICCIONES PARA LAS RONDAS 2+
  reestablecerPrediccionesRondasSiguientes();

  // Recalcular conexiones
  nextTick(() => {
    calcularCurvas();
  });

  showAlert({
    icon: "success",
    title: "Cruces restaurados y fase eliminatoria reiniciada.",
    text: "Todos los resultados han sido eliminados de TODAS las rondas.",
    timer: 2500,
    vm: proxy,
  });
}

const todosResultadosZonas = computed(() => {
  if (!torneo.value?.zonas) return false;

  // ⭐ DETECTAR MÍNIMO SEGÚN DEPORTE
  const minimosRequeridos = deporte.value === "Futbol" ? 1 : 2;

  return torneo.value.zonas.every((zona: any) =>
    zona.partidos.every(
      (partido: any) =>
        partido.sets &&
        partido.sets.length >= minimosRequeridos && // ✅ DINÁMICO
        partido.sets.every(
          (s: any) =>
            Number.isInteger(s.gamesLocal) &&
            Number.isInteger(s.gamesVisitante),
        ),
    ),
  );
});

const algunResultadoZona = computed(() => {
  if (!torneo.value?.zonas) return false;

  // ⭐ DETECTAR MÍNIMO SEGÚN DEPORTE
  const minimosRequeridos = deporte.value === "Futbol" ? 1 : 2;

  return torneo.value.zonas.some((zona: any) =>
    zona.partidos.some(
      (partido: any) =>
        partido.sets &&
        partido.sets.length >= minimosRequeridos && // ✅ DINÁMICO
        partido.sets.every(
          (s: any) =>
            Number.isInteger(s.gamesLocal) &&
            Number.isInteger(s.gamesVisitante),
        ),
    ),
  );
});

const campeon = computed(() => {
  console.log("campeon", torneo.value?.rondas);
  if (!torneo.value?.rondas || torneo.value.rondas.length === 0) return null;
  const finalRonda = torneo.value.rondas[torneo.value.rondas.length - 1];
  if (finalRonda.partidos.length === 1) {
    campeonKey.value++;
    estadoKey.value++;
    return finalRonda.partidos[0].ganador || null;
  }
  return null;
});

function abrirModalResultadoConAdvertencia(partido: any) {
  // Verificar si ya tiene resultado
  const tieneResultado =
    partido.resultado &&
    partido.sets &&
    partido.sets.some(
      (s: any) =>
        Number.isInteger(s.gamesLocal) && Number.isInteger(s.gamesVisitante),
    );

  if (tieneResultado) {
    // Verificar si este partido afecta a rondas posteriores
    const afectaRondasPosteriores = verificarSiAfectaRondasPosteriores(partido);

    if (afectaRondasPosteriores) {
      const confirmacion = confirm(
        `⚠️ ADVERTENCIA\n\nEste partido ya tiene resultados y afecta a partidos posteriores.\n\nSi cambia el resultado, se perderán todos los resultados de la rama afectada (partidos posteriores).\n\n¿Desea continuar?`,
      );

      if (!confirmacion) return;
    }
  }

  // Llamar a la función original
  abrirModalResultado(partido);
}

// Helper para verificar si es un objeto de equipo
function esObjetoEquipo(equipo: any): boolean {
  return (
    equipo && typeof equipo === "object" && "id" in equipo && "nombre" in equipo
  );
}

function obtenerNombreEquipo(equipo: any): string {
  if (!equipo) return "—";
  if (typeof equipo === "string") return equipo;
  if (esObjetoEquipo(equipo)) return equipo.nombre;
  return "—";
}

function abrirModalResultado(partido: any) {
  console.log("Abriendo modal de resultado para:", partido);

  // Validación para partidos de ZONA
  if (!partido.ronda && partido.local && partido.visitante) {
    console.log("Es un partido de zona");
    if (hayResultadosEnFaseEliminacion()) {
      showAlert({
        icon: "warning",
        title:
          "❌ Ya hay partidos jugados en la fase de eliminación.\n\nPara modificar resultados de zona, primero debe restaurar los cruces usando el botón '↺ Restaurar Cruces Guardados'.",
        timer: 4000,
        vm: proxy,
      });
      return;
    }
  }

  // Validaciones comunes - verificar que no sean strings (predicciones)
  const localEsPrediccion = typeof partido.local === "string";
  const visitanteEsPrediccion = typeof partido.visitante === "string";

  if (
    !partido.local ||
    !partido.visitante ||
    localEsPrediccion ||
    visitanteEsPrediccion
  ) {
    showAlert({
      icon: "warning",
      title: "Este partido aún no tiene participantes definidos.",
      timer: 4000,
      vm: proxy,
    });
    return;
  }

  partidoActivo.value = partido;

  // Preparar los sets
  sets.value =
    partido.sets && partido.sets.length
      ? partido.sets.map((s: any) => ({
          local: s.gamesLocal,
          visitante: s.gamesVisitante,
        }))
      : [
          { local: null, visitante: null },
          { local: null, visitante: null },
        ];

  modalResultadoVisible.value = true;
  console.log("Modal de resultado abierto");
}

function verificarSiAfectaRondasPosteriores(partido: any) {
  if (!torneo.value?.rondas || !partido.ganador) return false;

  const rondaActualIndex = torneo.value.rondas.findIndex(
    (r: any) => r.numero === partido.ronda,
  );

  if (
    rondaActualIndex === -1 ||
    rondaActualIndex >= torneo.value.rondas.length - 1
  ) {
    return false; // Es la última ronda
  }

  // Verificar si hay resultados en rondas posteriores en esta rama
  const rondaActual = torneo.value.rondas[rondaActualIndex];
  const indicePartido = rondaActual.partidos.findIndex(
    (p: any) => p.id === partido.id,
  );

  if (indicePartido === -1) return false;

  let indiceActual = Math.floor(indicePartido / 2);

  for (let i = rondaActualIndex + 1; i < torneo.value.rondas.length; i++) {
    const rondaSiguiente = torneo.value.rondas[i];
    const partidoSiguiente = rondaSiguiente.partidos[indiceActual];

    if (partidoSiguiente && partidoSiguiente.resultado) {
      return true; // Hay resultados en esta rama
    }

    indiceActual = Math.floor(indiceActual / 2);
  }

  return false;
}

function closeModalResultado() {
  modalResultadoVisible.value = false;
  partidoActivo.value = null;
  sets.value = [];
}

function esEquipoTemporal(equipo: any) {
  return equipo && typeof equipo === "object" && equipo._temporal === true;
}

// Función para resetear la rama del árbol desde un partido específico
function resetearRamaDesdePartido(partidoModificado: any) {
  if (!torneo.value?.rondas || !partidoModificado) return;

  console.log(
    `🔧 Resetando rama desde P${partidoModificado.id} (Ronda ${partidoModificado.ronda})`,
  );

  const rondaActualIndex = partidoModificado.ronda - 1;
  const rondaActual = torneo.value.rondas[rondaActualIndex];

  if (!rondaActual) return;

  const indicePartido = rondaActual.partidos.findIndex(
    (p: any) => p.id === partidoModificado.id,
  );

  if (indicePartido === -1) return;

  // ⭐ CALCULAR MITAD DEL CUADRO
  const totalPartidosRonda = rondaActual.partidos.length;
  const mitadPartidos = totalPartidosRonda / 2;
  const esLadoIzquierdo = indicePartido < mitadPartidos;
  const indiceEnMitad = esLadoIzquierdo
    ? indicePartido
    : indicePartido - mitadPartidos;
  const esLocalEnRondaActual = indiceEnMitad % 2 === 0;

  console.log(
    `📊 Índice: ${indicePartido}, Lado: ${
      esLadoIzquierdo ? "IZQ" : "DER"
    }, Posición: ${esLocalEnRondaActual ? "LOCAL" : "VISITANTE"}`,
  );

  // ⭐ PASO 1: ENCONTRAR EL PARTIDO SIGUIENTE (ronda N+1)
  const rondaSiguienteIndex = rondaActualIndex + 1;
  const rondaSiguiente = torneo.value.rondas[rondaSiguienteIndex];

  if (!rondaSiguiente) {
    console.log(`⚠️ No hay ronda siguiente`);
    return;
  }

  // Calcular índice en la ronda siguiente
  const indiceEnRondaSiguiente = Math.floor(indiceEnMitad / 2);
  const indicePartidoSiguiente = esLadoIzquierdo
    ? indiceEnRondaSiguiente
    : rondaSiguiente.partidos.length / 2 + indiceEnRondaSiguiente;

  const partidoSiguiente = rondaSiguiente.partidos[indicePartidoSiguiente];

  if (!partidoSiguiente) {
    console.log(
      `⚠️ No hay partido en ronda ${
        rondaSiguienteIndex + 1
      }, índice ${indicePartidoSiguiente}`,
    );
    return;
  }

  console.log(
    `🎯 Partido siguiente: P${partidoSiguiente.id} en ronda ${rondaSiguiente.numero}`,
  );

  // ⭐ PASO 2: ACTUALIZAR SOLO EL LADO AFECTADO EN RONDA N+1
  const vieneComoLocal = esLocalEnRondaActual;

  if (vieneComoLocal) {
    // Actualizar solo el LOCAL (lado afectado)
    partidoSiguiente.local = partidoModificado.ganador || {
      nombre: `Ganador P${partidoModificado.id}`,
    };
    console.log(`✓ Actualizado LOCAL: ${partidoSiguiente.local.nombre}`);

    // Mantener el VISITANTE (rival)
    if (!partidoSiguiente.visitante) {
      const indiceOponente = esLocalEnRondaActual
        ? indicePartido + 1
        : indicePartido - 1;
      const partidoOponente = rondaActual.partidos[indiceOponente];

      if (partidoOponente) {
        partidoSiguiente.visitante = {
          nombre: `Ganador P${partidoOponente.id}`,
        };
        console.log(
          `✓ Establecido VISITANTE (predicción): Ganador P${partidoOponente.id}`,
        );
      }
    }
  } else {
    // Actualizar solo el VISITANTE (lado afectado)
    partidoSiguiente.visitante = partidoModificado.ganador || {
      nombre: `Ganador P${partidoModificado.id}`,
    };
    console.log(
      `✓ Actualizado VISITANTE: ${partidoSiguiente.visitante.nombre}`,
    );

    // Mantener el LOCAL (rival)
    if (!partidoSiguiente.local) {
      const indiceOponente = esLocalEnRondaActual
        ? indicePartido + 1
        : indicePartido - 1;
      const partidoOponente = rondaActual.partidos[indiceOponente];

      if (partidoOponente) {
        partidoSiguiente.local = { nombre: `Ganador P${partidoOponente.id}` };
        console.log(
          `✓ Establecido LOCAL (predicción): Ganador P${partidoOponente.id}`,
        );
      }
    }
  }

  // ⭐ PASO 3: RESETEAR RESULTADO DEL PARTIDO SIGUIENTE
  partidoSiguiente.ganador = null;
  partidoSiguiente.resultado = "";
  const minimosRequeridos = deporte.value === "Futbol" ? 1 : 2;
  partidoSiguiente.sets = Array.from({ length: minimosRequeridos }, () => ({
    gamesLocal: null,
    gamesVisitante: null,
  }));

  console.log(`✓ Resultado de P${partidoSiguiente.id} reseteado`);

  // ⭐ PASO 4: PROPAGAR EL CAMBIO HACIA LAS RONDAS POSTERIORES
  // Esto es lo que estaba faltando - convertir a predicción en rondas N+2+
  propagarCambioHaciaRondasPosteriores(
    partidoSiguiente,
    esLadoIzquierdo,
    vieneComoLocal,
  );

  // Forzar actualización visual
  campeonKey.value++;
  console.log(`✅ Cambio aplicado correctamente`);
}

function guardarResultado(modalSets: any) {
  if (!partidoActivo.value) return;

  // IMPORTANTE: Obtener el deporte actual
  const deporteActual = deporte.value || "tenis"; // Variable reactiva que debe existir en el componente

  // ============================================
  // VALIDACIONES SEGÚN DEPORTE
  // ============================================
  if (deporteActual === "Futbol") {
    // FÚTBOL: Solo necesita 1 "set" (que contiene los goles)
    if (modalSets.length < 1) {
      showAlert({
        icon: "warning",
        title: "Debe ingresar el resultado del partido.",
        timer: 4000,
        vm: proxy,
      });
      return;
    }

    const goles = modalSets[0];
    if (
      !Number.isInteger(goles.gamesLocal) ||
      !Number.isInteger(goles.gamesVisitante) ||
      goles.gamesLocal < 0 ||
      goles.gamesVisitante < 0
    ) {
      showAlert({
        icon: "warning",
        title: "Debe ingresar la cantidad de goles de ambos equipos.",
        timer: 4000,
        vm: proxy,
      });
      return;
    }

    // VALIDACIÓN ESPECIAL: En eliminación NO puede haber empates
    const esEliminacion = partidoActivo.value.ronda !== undefined;
    if (esEliminacion && goles.gamesLocal === goles.gamesVisitante) {
      showAlert({
        icon: "warning",
        title:
          "En fase de eliminación no puede haber empates. Debe definirse un ganador.",
        timer: 4000,
        vm: proxy,
      });
      return;
    }
  } else {
    // TENIS/PADEL: Necesita mínimo 2 sets
    if (modalSets.length < 2) {
      showAlert({
        icon: "warning",
        title: "Se necesitan mínimo 2 sets.",
        timer: 4000,
        vm: proxy,
      });
      return;
    }

    for (let i = 0; i < modalSets.length; i++) {
      const s = modalSets[i];
      if (
        !Number.isInteger(s.gamesLocal) ||
        !Number.isInteger(s.gamesVisitante)
      ) {
        showAlert({
          icon: "warning",
          title: "Completar todos los games de cada set con números enteros.",
          timer: 4000,
          vm: proxy,
        });
        return;
      }

      if (s.gamesLocal < 0 || s.gamesVisitante < 0) {
        showAlert({
          icon: "warning",
          title: "Los games no pueden ser números negativos.",
          timer: 4000,
          vm: proxy,
        });
        return;
      }
    }
  }

  // ============================================
  // GUARDAR GANADOR ANTERIOR
  // ============================================
  const ganadorAnterior = partidoActivo.value.ganador;

  // ============================================
  // CALCULAR GANADOR Y RESULTADO USANDO UTILIDAD
  // ============================================

  const { ganador, resultado } = calcularGanador(
    modalSets,
    partidoActivo.value.local,
    partidoActivo.value.visitante,
    deporteActual,
  );

  // Guardar sets (normalizados)
  partidoActivo.value.sets = modalSets.map((s: any) => ({
    gamesLocal: Number(s.gamesLocal),
    gamesVisitante: Number(s.gamesVisitante),
  }));

  // Asignar ganador y resultado
  partidoActivo.value.ganador = ganador;
  partidoActivo.value.resultado = resultado;

  // ============================================
  // LIMPIAR FLAGS TEMPORALES (solo para torneos)
  // ============================================
  if (typeof limpiarFlagsTemporales === "function") {
    limpiarFlagsTemporales();
  }

  // ============================================
  // DETECTAR SI ES MODIFICACIÓN
  // ============================================
  const esModificacion =
    ganadorAnterior !== null && ganadorAnterior !== undefined;

  // ============================================
  // ACTUALIZAR SIGUIENTES RONDAS (solo torneos)
  // ============================================
  if (partidoActivo.value.ronda) {
    // Es un partido de eliminación
    if (esModificacion && ganadorAnterior?.id !== ganador?.id) {
      // El ganador cambió: resetear rama completa
      console.log(
        `¡Ganador cambiado! Resetando rama desde P${partidoActivo.value.id}`,
      );

      if (typeof resetearRamaDesdePartido === "function") {
        resetearRamaDesdePartido(partidoActivo.value);
      }
    } else {
      // Ganador igual o es nuevo: actualizar normalmente
      if (typeof actualizarSiguienteRonda === "function") {
        actualizarSiguienteRonda({ ...partidoActivo.value });
      }

      if (typeof forzarRecalculoCurvas === "function") {
        forzarRecalculoCurvas();
      }
    }
  }

  // ============================================
  // CERRAR MODAL Y LIMPIAR
  // ============================================
  modalResultadoVisible.value = false;

  // Forzar reactividad (si es necesario)
  if (torneo.value) {
    torneo.value = { ...torneo.value };
  }

  partidoActivo.value = null;

  // ============================================
  // MOSTRAR CONFIRMACIÓN
  // ============================================
  showAlert({
    icon: "success",
    title: "Resultado guardado correctamente.",
    timer: 2500,
    vm: proxy,
  });
}

function editarNombreEquipoEliminacion(
  partido: any,
  ronda: any,
  condicion: string,
) {
  // Guardar referencia al partido y equipo a editar
  console.log("partido", partido);
  const equipoAEditar =
    condicion === "local" ? partido.local : partido.visitante;

  if (!equipoAEditar) {
    showAlert({
      icon: "warning",
      title: "No hay equipo para editar en este partido.",
      timer: 3000,
      vm: proxy,
    });
    return;
  }

  // Determinar cuál equipo estamos editando
  const esLocal = partido.local === equipoAEditar;

  // Obtener IDs de jugadores ya usados (excluyendo el equipo actual)
  const idsUsados = obtenerIdsJugadoresUsados(equipoAEditar);

  equipoActivo.value = equipoAEditar;

  // Guardar los IDs usados en el equipo activo
  equipoActivo.value._idsUsados = idsUsados;

  zonaActiva.value = {
    partido,
    esLocal,
    ronda,
  };

  if (!usaJugadores.value) {
    // ⭐ FÚTBOL: Editar nombre directamente
    editarNombreEquipoFutbol(equipoActivo.value, zonaActiva.value);
    return;
  }

  modalAsignarJugadoresVisible.value = true;
}

function editarNombreEquipo(zona: any, equipo: any) {
  if (estadoTorneo.value === "Publicado") {
    showAlert({
      icon: "warning",
      title: "El torneo ya está publicado. Vuelva a ponerlo en estado Draft.",
      timer: 5000,
      vm: proxy,
    });
    return;
  }

  if (!usaJugadores.value) {
    // ⭐ FÚTBOL: Editar nombre directamente
    editarNombreEquipoFutbol(equipo, zona);
    return;
  }

  // TENIS/PADEL: Asignar jugadores
  equipoActivo.value = equipo;
  zonaActiva.value = zona;
  equipoActivo.value._idsUsados = obtenerIdsJugadoresUsados(equipo);
  modalAsignarJugadoresVisible.value = true;
}

function editarNombreEquipoFutbol(equipo: any, zona?: any) {
  if (estadoTorneo.value === "Publicado") {
    showAlert({
      icon: "warning",
      title: "El torneo ya está publicado.",
      timer: 5000,
      vm: proxy,
    });
    return;
  }

  equipoActivo.value = equipo;
  zonaActiva.value = zona || null;
  modalAsignarNombreVisible.value = true;
}

function asignarNombreEquipoFutbol(nombre: string) {
  if (!equipoActivo.value) return;

  const equipoId = equipoActivo.value.id;
  equipoActivo.value.nombre = nombre;

  // ⭐ VARIABLE PARA GUARDAR PARTIDOS CON BYE
  const partidosConBye: any[] = [];

  // Propagar cambio a todos los partidos
  if (torneo.value && equipoId) {
    // En zonas
    if (torneo.value.zonas) {
      torneo.value.zonas.forEach((zona: any) => {
        zona.partidos.forEach((partido: any) => {
          if (partido.local?.id === equipoId) partido.local.nombre = nombre;
          if (partido.visitante?.id === equipoId)
            partido.visitante.nombre = nombre;
          if (partido.ganador?.id === equipoId) partido.ganador.nombre = nombre;
        });
      });
    }

    // En eliminación
    if (torneo.value.rondas) {
      torneo.value.rondas.forEach((ronda: any) => {
        ronda.partidos.forEach((partido: any) => {
          // ⭐ DETECTAR BYE ANTES DE ACTUALIZAR NOMBRES - CONDICIÓN CORREGIDA
          if (partido.pasaAutomatico) {
            console.log("here");
            // Verificar si es un BYE donde este equipo es el único presente
            const esLocalConBye =
              partido.local?.id === equipoId && !partido.visitante;
            const esVisitanteConBye =
              partido.visitante?.id === equipoId && !partido.local;

            if (esLocalConBye || esVisitanteConBye) {
              partidosConBye.push(partido);
            }
          }

          // Actualizar nombres
          if (partido.local?.id === equipoId) partido.local.nombre = nombre;
          if (partido.visitante?.id === equipoId)
            partido.visitante.nombre = nombre;
          if (partido.ganador?.id === equipoId) partido.ganador.nombre = nombre;
        });
      });
    }
  }

  // ⭐ PROCESAR BYEs DESPUÉS DE ACTUALIZAR TODOS LOS NOMBRES
  if (partidosConBye.length > 0) {
    console.log(
      `🔍 Encontré ${partidosConBye.length} partidos con BYE para actualizar`,
    );

    partidosConBye.forEach((partido: any) => {
      const ganador = partido.local || partido.visitante;

      if (ganador) {
        console.log(
          `🎯 Procesando BYE para ${ganador.nombre} en P${partido.id}`,
        );

        partido.ganador = ganador;
        partido.resultado = `BYE (avanza ${ganador.nombre})`;

        // ⭐ AVANZAR A LA SIGUIENTE RONDA
        actualizarSiguienteRonda(partido);

        console.log(`✅ ${ganador.nombre} avanzó automáticamente por BYE`);
      }
    });
  }

  hayCambiosSinGuardar.value = true;
  modalAsignarNombreVisible.value = false;
  equipoActivo.value = null;
  zonaActiva.value = null;

  showAlert({
    icon: "success",
    title: `Nombre del equipo actualizado: ${nombre}`,
    timer: 2500,
    vm: proxy,
  });
}

function asignarJugadoresAEquipoActivo(jugadores: any) {
  console.log("jugadores", jugadores);
  const splitJugador1 = jugadores.jugador1.value.nombreJugador.split(",");
  const nombreJugador1 =
    splitJugador1[0] + " " + splitJugador1[1].trim().substr(0, 1) + ".";
  const idJugador1 = jugadores.jugador1.value.idJugador;

  let nombreJugador2 = "";
  let idJugador2 = null;

  if (tipoCompetenciaTorneo.value === "Dobles") {
    const splitJugador2 = jugadores.jugador2.value.nombreJugador.split(",");
    nombreJugador2 =
      splitJugador2[0] + " " + splitJugador2[1].trim().substr(0, 1) + ".";
    idJugador2 = jugadores.jugador2.value.idJugador;
  }

  let nombreEquipo = nombreJugador1;

  if (tipoCompetenciaTorneo.value === "Dobles") {
    nombreEquipo += ` - ${nombreJugador2}`;
  }

  const ids = { idJugador1, idJugador2 };

  if (ids.idJugador2 == null) {
    delete ids.idJugador2;
  }

  // CASO ESPECIAL: Eliminación directa
  if (modalidad.value === "eliminacion_directa" && zonaActiva.value?.partido) {
    const partido = zonaActiva.value.partido;
    const esLocal = zonaActiva.value.esLocal;

    // Actualizar el equipo directamente en el partido
    const equipoActualizado = {
      ...equipoActivo.value,
      nombre: nombreEquipo,
      ids,
    };

    if (esLocal) {
      partido.local = equipoActualizado;
    } else {
      partido.visitante = equipoActualizado;
    }

    // Propagar cambios a rondas siguientes si ya tiene ganador
    if (partido.ganador && partido.ganador.id === equipoActivo.value.id) {
      partido.ganador = equipoActualizado;
      actualizarSiguienteRonda(partido);
    }
  } else {
    // CASO NORMAL: Zonas (código existente)
    actualizarNombreEquipoEnObjeto(
      torneo.value,
      equipoActivo.value?.id,
      nombreEquipo,
      ids,
    );
  }

  modalAsignarJugadoresVisible.value = false;
  equipoActivo.value = null;
  zonaActiva.value = null;
}

// Función para resetear jugadores de un equipo en ZONAS
async function resetearJugadoresEquipo(equipo: any, zona: any) {
  if (!usaJugadores.value) {
    // Fútbol no tiene esta opción
    return;
  }
  if (estadoTorneo.value === "Publicado") {
    showAlert({
      icon: "warning",
      title:
        "El torneo ya está publicado. Vuelva a ponerlo en estado Draft para resetear jugadores.",
      timer: 5000,
      vm: proxy,
    });
    return;
  }

  if (hayResultadosEnFaseEliminacion()) {
    showAlert({
      icon: "warning",
      title:
        "❌ Ya hay partidos jugados en la fase de eliminación.\n\nPara resetear jugadores, primero debe restaurar los cruces.",
      timer: 4000,
      vm: proxy,
    });
    return;
  }

  const result = await confirmModal({
    vm: proxy,
    title: "Resetear jugadores",
    text: `¿Está seguro que desea resetear los jugadores del equipo "${equipo.nombre}"? El nombre volverá a su valor por defecto.`,
    icon: "warning",
    showCancelButton: true,
    showCloseButton: true,
    confirmButtonText: "Sí, resetear",
    cancelButtonText: "Cancelar",
  });

  if (!result.isConfirmed) return;

  // Resetear el nombre al valor por defecto basado en el ID
  const nombrePorDefecto = `Equipo ${zona.id}-${
    zona.equipos.indexOf(equipo) + 1
  }`;

  // Eliminar los ids de jugadores
  delete equipo.ids;

  // Restaurar nombre por defecto
  equipo.nombre = nombrePorDefecto;

  showAlert({
    icon: "success",
    title: `Jugadores del equipo reseteados correctamente.`,
    timer: 2500,
    vm: proxy,
  });

  console.log(`🔄 Equipo reseteado: ${equipo.nombre}`);
}

async function confirmaFinalizacionTorneo() {
  const result = await confirmModal({
    vm: proxy,
    title: "Finalizar torneo.",
    text: "¿Está seguro que desea finalizar el torneo? Esta acción no se puede deshacer.",
    icon: "warning",
    showCancelButton: true,
    showCloseButton: true,
  });

  if (!result.isConfirmed) {
    return;
  }

  abrirModalFinalizar();
}

// Función para resetear jugadores de un equipo en ELIMINACIÓN DIRECTA
async function resetearJugadoresEquipoEliminacion(
  partido: any,
  posicion: "local" | "visitante",
) {
  if (estadoTorneo.value === "Finalizado") {
    showAlert({
      icon: "warning",
      title: "El torneo ya está finalizado. No se pueden resetear jugadores.",
      timer: 4000,
      vm: proxy,
    });
    return;
  }

  const equipo = posicion === "local" ? partido.local : partido.visitante;

  if (!equipo || !esObjetoEquipo(equipo)) {
    showAlert({
      icon: "warning",
      title: "No hay equipo para resetear.",
      timer: 3000,
      vm: proxy,
    });
    return;
  }

  const result = await confirmModal({
    vm: proxy,
    title: "Resetear jugadores",
    text: `¿Está seguro que desea resetear los jugadores del equipo "${equipo.nombre}"? El nombre volverá a su valor por defecto.`,
    icon: "warning",
    showCancelButton: true,
    showCloseButton: true,
    confirmButtonText: "Sí, resetear",
    cancelButtonText: "Cancelar",
  });

  if (!result.isConfirmed) return;

  // Resetear el nombre al valor por defecto basado en el ID
  const nombrePorDefecto = `Equipo ${equipo.id}`;

  // Crear equipo reseteado
  const equipoReseteado = {
    id: equipo.id,
    nombre: nombrePorDefecto,
  };

  // Actualizar el partido
  if (posicion === "local") {
    partido.local = equipoReseteado;
  } else {
    partido.visitante = equipoReseteado;
  }

  // Si este equipo era el ganador, resetear el ganador también
  if (partido.ganador && partido.ganador.id === equipo.id) {
    partido.ganador = null;
    partido.resultado = "";
    const minimosRequeridos = deporte.value === "Futbol" ? 1 : 2;
    partido.sets = Array.from({ length: minimosRequeridos }, () => ({
      gamesLocal: null,
      gamesVisitante: null,
    }));

    // Resetear rondas posteriores
    resetearRamaDesdePartido(partido);
  }

  // Propagar cambios a través de las rondas si el equipo ya avanzó
  if (partido.ganador && partido.ganador.id === equipo.id) {
    actualizarSiguienteRonda(partido);
  }

  showAlert({
    icon: "success",
    title: `Jugadores del equipo reseteados correctamente.`,
    timer: 2500,
    vm: proxy,
  });

  console.log(`🔄 Equipo reseteado en eliminación: ${equipoReseteado.nombre}`);

  // Forzar actualización visual
  nextTick(() => {
    calcularCurvas();
  });
}

function obtenerIdsJugadoresUsados(equipoExcluido?: any): number[] {
  const idsUsados: number[] = [];

  if (!torneo.value) return idsUsados;

  // Función helper para extraer IDs de un equipo
  const extraerIdsDeEquipo = (equipo: any) => {
    if (!equipo || !esObjetoEquipo(equipo)) return;

    // Si es el equipo que estamos editando, no incluir sus IDs
    if (equipoExcluido && equipo.id === equipoExcluido.id) return;

    if (equipo.ids) {
      if (equipo.ids.idJugador1) {
        idsUsados.push(equipo.ids.idJugador1);
      }
      if (equipo.ids.idJugador2) {
        idsUsados.push(equipo.ids.idJugador2);
      }
    }
  };

  // CASO 1: Torneo con ZONAS
  if (torneo.value.zonas && Array.isArray(torneo.value.zonas)) {
    torneo.value.zonas.forEach((zona: any) => {
      if (zona.equipos && Array.isArray(zona.equipos)) {
        zona.equipos.forEach((equipo: any) => {
          extraerIdsDeEquipo(equipo);
        });
      }
    });
  }

  // CASO 2: Torneo de ELIMINACIÓN DIRECTA
  // Recorrer todas las rondas y extraer equipos
  if (torneo.value.rondas && Array.isArray(torneo.value.rondas)) {
    // Solo necesitamos revisar la primera ronda, ya que los equipos se repiten
    const primeraRonda = torneo.value.rondas[0];

    if (primeraRonda && primeraRonda.partidos) {
      primeraRonda.partidos.forEach((partido: any) => {
        extraerIdsDeEquipo(partido.local);
        extraerIdsDeEquipo(partido.visitante);
      });
    }
  }

  // Eliminar duplicados
  const idsUnicos = [...new Set(idsUsados)];

  console.log(`📋 IDs de jugadores ya usados en el torneo:`, idsUnicos);
  console.log(`🚫 Equipo excluido:`, equipoExcluido?.nombre || "Ninguno");

  return idsUnicos;
}

function actualizarNombreEquipoEnObjeto(
  obj: any,
  equipoId: any,
  nuevoNombre: any,
  ids: any,
) {
  if (Array.isArray(obj)) {
    obj.forEach((item) =>
      actualizarNombreEquipoEnObjeto(item, equipoId, nuevoNombre, ids),
    );
    return;
  }

  if (obj && typeof obj === "object") {
    if (
      obj.id === equipoId &&
      typeof obj.nombre === "string" &&
      !obj.equipos?.length
    ) {
      obj.nombre = nuevoNombre;

      // Si ids es null o undefined, eliminar la propiedad
      if (ids === null || ids === undefined) {
        delete obj.ids;
      } else {
        obj.ids = ids;
      }
    }

    Object.values(obj).forEach((value) =>
      actualizarNombreEquipoEnObjeto(value, equipoId, nuevoNombre, ids),
    );
  }
}

async function eliminarEquipo(zona: any, equipo: any) {
  if (estadoTorneo.value === "Publicado") {
    showAlert({
      icon: "warning",
      title:
        "El torneo ya está publicado. Vuelva a ponerlo en estado Draft para eliminar el equipo.",
      timer: 5000,
      vm: proxy,
    });
    return;
  }
  if (estadoTorneo.value === "Finalizado") {
    showAlert({
      icon: "warning",
      title: "El torneo ya está finalizado. No se pueden mover los equipos.",
      timer: 4000,
      vm: proxy,
    });
    return;
  }
  // Verificar si ya hay resultados en fase eliminatoria
  if (hayResultadosEnFaseEliminacion()) {
    showAlert({
      icon: "warning",
      title:
        "❌ Ya hay partidos jugados en la fase de eliminación.\n\nPara eliminar equipos, primero debe restaurar los cruces usando el botón '↺ Restaurar Cruces Guardados'.",
      timer: 5000,
      vm: proxy,
    });
    return;
  }

  const equipoIndex = zona.equipos.findIndex((e: any) => e.id === equipo.id);

  if (equipoIndex === -1) {
    showAlert({
      icon: "warning",
      title: `No se encotró el equipo.`,
      timer: 4000,
      vm: proxy,
    });
    return;
  }

  // Verificar cantidad mínima de equipos
  if (zona.equipos.length <= 2) {
    showAlert({
      icon: "warning",
      title: `No se puede eliminar. La ${zona.nombre} necesita al menos 2 equipos.`,
      timer: 4000,
      vm: proxy,
    });
    return;
  }

  const result = await confirmModal({
    vm: proxy,
    title: "Eliminar equipo.",
    text: "¿Está seguro que desea eliminar el equipo? Se regenerarán los partidos.",
    icon: "warning",
    showCancelButton: true,
    showCloseButton: true,
  });

  if (!result.isConfirmed) {
    return;
  }

  // Eliminar equipo
  zona.equipos.splice(equipoIndex, 1);
  total.value -= 1;
  torneo.value.total -= 1;

  // Eliminar partidos relacionados con este equipo
  if (zona.partidos) {
    // Filtrar partidos donde participa el equipo eliminado
    const partidosAEliminar = zona.partidos.filter(
      (partido: any) =>
        partido.local?.id === equipo.id || partido.visitante?.id === equipo.id,
    );

    // Eliminar esos partidos
    partidosAEliminar.forEach((partido: any) => {
      const partidoIndex = zona.partidos.findIndex(
        (p: any) => p.id === partido.id,
      );
      if (partidoIndex !== -1) {
        zona.partidos.splice(partidoIndex, 1);
      }
    });

    // Regenerar todos los partidos de la zona
    zona.partidos = generarPartidosDeZona(zona.equipos, deporte.value);

    // Reasignar IDs a los partidos restantes
    zona.partidos.forEach((partido: any, index: number) => {
      partido.id = index + 1;
    });
  }

  // Actualizar fase de eliminación si ya hay resultados
  if (todosResultadosZonas.value) {
    actualizarFaseEliminacion();
  }

  showAlert({
    icon: "success",
    title: `Equipo "${equipo.nombre}" eliminado de la ${zona.nombre}`,
    timer: 2500,
    vm: proxy,
  });
}

// Y esta función para limpiar refs viejos
function limpiarRefsPartidos() {
  Object.keys(partidoRefs).forEach((key) => {
    delete partidoRefs[key];
    console.log("🧹 Refres de partidos limpiados");
  });
}

async function generarTorneoClick() {
  try {
    console.log("🚀 Generando torneo...");

    if (estadoTorneo.value === "Publicado") {
      showAlert({
        icon: "warning",
        title:
          "El torneo ya está publicado. Vuelva a ponerlo en estado Draft para generar o regenerar los partidos.",
        timer: 4000,
        vm: proxy,
      });
      return;
    }

    if (+total.value > 256) {
      showAlert({
        icon: "warning",
        title: "La cantidad total de equipos no puede ser mayor a 256.",
        timer: 4000,
        vm: proxy,
      });
      return;
    }

    if (modalidad.value === "zonas_y_eliminacion" && !clasificados.value) {
      showAlert({
        icon: "warning",
        title: "Debe definir la cantidad total de clasificados.",
        timer: 4000,
        vm: proxy,
      });
      return;
    }

    if (algunResultadoZona.value || hayResultadosEnFaseEliminacion()) {
      const result = await confirmModal({
        vm: proxy,
        title: "Torneo empezado.",
        text: "Hay resultados cargados, si regenera los partidos se perderán los mismos. ¿Desea regenerar los partidos de todas maneras?",
        icon: "warning",
        showCancelButton: true,
        showCloseButton: true,
      });

      if (!result.isConfirmed) {
        return;
      }
    }

    // Limpiar refs anteriores
    limpiarRefsPartidos();
    curves.value = [];
    partidoRefsReady.value = false;

    // Generar torneo
    torneo.value = generarTorneo(
      total.value,
      modalidad.value,
      clasificados.value,
      zonasDeseadas.value,
      estrategiaByes.value,
      deporte.value,
    );

    if (!torneo.value) {
      console.warn("❌ generarTorneo devolvió null");
      showAlert({
        icon: "warning",
        title:
          "Los partidos no pudieros ser generados con los parámetros ingresados.",
        timer: 4000,
        vm: proxy,
      });
      return;
    }

    console.log(
      `✅ Torneo generado con ${torneo.value.rondas?.length || 0} rondas`,
    );

    // Guardar partidos originales
    if (torneo.value.rondas?.[0]?.partidos) {
      partidosOriginalesRonda1.value = JSON.parse(
        JSON.stringify(torneo.value.rondas[0].partidos),
      );
      console.log(
        `💾 Partidos originales guardados: ${partidosOriginalesRonda1.value.length}`,
      );
    }

    // Crear zonas si es necesario
    if (
      torneo.value.participantesPorZona &&
      modalidad.value === "zonas_y_eliminacion"
    ) {
      ignoreNextZonaChange.value = true;

      torneo.value.zonas = torneo.value.participantesPorZona.map(
        (cant: number, index: number) => {
          const equipos = Array.from({ length: cant }, (_, i) => ({
            id: index * 1000 + i + 1,
            nombre: `Equipo ${index + 1}-${i + 1}`,
          }));

          const zona = {
            id: index + 1,
            nombre: `Zona ${index + 1}`,
            equipos,
            partidos: [],
            cantClasificados: torneo.value.clasificadosPorZona[index],
          };

          zona.partidos = generarPartidosDeZona(zona.equipos, deporte.value);
          console.log(
            `🏟️ Zona ${zona.id} creada con ${zona.equipos.length} equipos`,
          );
          return zona;
        },
      );
    }

    // Esperar múltiples ciclos de renderizado
    await nextTick();
    await nextTick();
    await nextTick(); // Un ciclo adicional

    // Marcar que los refs están listos
    partidoRefsReady.value = true;
    console.log("✅ Refs marcados como listos");

    await guardarCambios();

    showAlert({
      icon: "success",
      title: "Partidos generados exitosamente!",
      timer: 2500,
      vm: proxy,
    });

    // Cambiar a la pestaña apropiada
    if (modalidad.value === "eliminacion_directa") {
      tab.value = 2; // Ir directamente a fase eliminación
      console.log("➡️ Cambiando a pestaña Eliminación Directa");
    } else {
      tab.value = 1; // Ir a zonas
      console.log("➡️ Cambiando a pestaña Zonas");
    }

    ignoreNextZonaChange.value = false;
  } catch (error) {
    showAlert({
      icon: "warning",
      title: error || error.message,
      timer: 4000,
      vm: proxy,
    });
  }
}

function agregarEquipo(zona: any) {
  if (estadoTorneo.value === "Publicado") {
    showAlert({
      icon: "warning",
      title:
        "El torneo ya está publicado. Vuelva a ponerlo en estado Draft para agregar equipo.",
      timer: 5000,
      vm: proxy,
    });
    return;
  }

  if (estadoTorneo.value === "Finalizado") {
    showAlert({
      icon: "warning",
      title: "El torneo ya está finalizado. No se pueden mover los equipos.",
      timer: 4000,
      vm: proxy,
    });
    return;
  }

  // Verificar si ya hay resultados en fase eliminatoria
  if (hayResultadosEnFaseEliminacion()) {
    showAlert({
      icon: "warning",
      title:
        "❌ Ya hay partidos jugados en la fase de eliminación.\n\nPara agregar equipos, primero debe restaurar los cruces usando el botón '↺ Restaurar Cruces Guardados'.",
      timer: 4000,
      vm: proxy,
    });
    return;
  }

  if (todosResultadosZonas.value) {
    showAlert({
      icon: "warning",
      title: "Ya se jugaron todos los partidos de zona.",
      timer: 4000,
      vm: proxy,
    });
    return;
  }

  zona.equipos.push({
    id: Date.now(),
    nombre: `Equipo ${zona.id}-${zona.equipos.length + 1}`,
  });
  total.value += 1;
  torneo.value.total += 1;

  regenerarPartidosDeZona(zona);

  showAlert({
    icon: "success",
    title: `Equipo agregado exitosamente a la zona ${zona.nombre}.`,
    timer: 2500,
    vm: proxy,
  });
}

function calcularCurvas() {
  // Evitar loops - no calcular si ya estamos calculando
  if (calculandoCurvas.value) {
    console.log("⏸️ Ya se están calculando curvas, omitiendo...");
    return;
  }

  // Debounce: no calcular más de una vez cada 500ms
  const ahora = Date.now();
  if (ahora - ultimoCalculo.value < 500) {
    console.log("⏸️ Debounce: esperando...");
    return;
  }

  calculandoCurvas.value = true;
  ultimoCalculo.value = ahora;

  console.log("🔧 Calculando curvas...");

  try {
    curves.value = [];

    if (
      !torneo.value ||
      !torneo.value.rondas ||
      torneo.value.rondas.length < 2
    ) {
      console.log("⚠️ No hay suficientes rondas para calcular curvas");
      return;
    }

    if (!rondasContainer.value) {
      console.warn("❌ No se encontró el contenedor de rondas");
      return;
    }

    // Actualizar dimensiones una sola vez
    svgWidth.value = rondasContainer.value.offsetWidth;
    svgHeight.value = rondasContainer.value.offsetHeight;

    console.log(`📐 Dimensiones SVG: ${svgWidth.value}x${svgHeight.value}`);
    console.log(`📊 Refs disponibles: ${Object.keys(partidoRefs).length}`);

    // Calcular de inmediato (sin setTimeout interno)
    const nuevasCurves: Array<{ id: string; d: string }> = [];
    const rectContainer = rondasContainer.value!.getBoundingClientRect();

    torneo.value.rondas.forEach((ronda: any, rondaIndex: number) => {
      if (rondaIndex >= torneo.value.rondas.length - 1) return;

      const siguienteRonda = torneo.value.rondas[rondaIndex + 1];

      ronda.partidos.forEach((partido: any, partidoIndex: number) => {
        const siguientePartidoIndex = Math.floor(partidoIndex / 2);
        const siguientePartido = siguienteRonda.partidos[siguientePartidoIndex];

        if (!siguientePartido) return;

        const elementoPartido = partidoRefs[partido.id];
        const elementoSiguiente = partidoRefs[siguientePartido.id];

        if (!elementoPartido || !elementoSiguiente) {
          console.log(
            `⚠️ Falta ref para P${partido.id} o P${siguientePartido.id}`,
          );
          return;
        }

        try {
          const elPartido = elementoPartido.$el || elementoPartido;
          const elSiguiente = elementoSiguiente.$el || elementoSiguiente;

          const rectPartido = elPartido.getBoundingClientRect();
          const rectSiguiente = elSiguiente.getBoundingClientRect();

          // Convertir a coordenadas relativas al contenedor
          const x1 = rectPartido.right - rectContainer.left;
          const y1 =
            rectPartido.top + rectPartido.height / 2 - rectContainer.top;
          const x2 = rectSiguiente.left - rectContainer.left;
          const y2 =
            rectSiguiente.top + rectSiguiente.height / 2 - rectContainer.top;

          // Línea en "L"
          const puntoMedioX = (x1 + x2) / 2;
          const d = `M ${x1},${y1}
                    L ${puntoMedioX},${y1}
                    L ${puntoMedioX},${y2}
                    L ${x2},${y2}`;

          nuevasCurves.push({
            id: `${partido.id}-${siguientePartido.id}`,
            d,
          });
        } catch (error) {
          console.error(
            `Error en línea ${partido.id}->${siguientePartido.id}:`,
            error,
          );
        }
      });
    });

    // Asignar una sola vez
    curves.value = nuevasCurves;
    console.log(`✅ ${curves.value.length} líneas calculadas`);
  } catch (error) {
    console.error("❌ Error calculando curvas:", error);
  } finally {
    // Liberar el flag después de un breve delay
    setTimeout(() => {
      calculandoCurvas.value = false;
    }, 100);
  }
}

async function volver() {
  if (hayCambiosSinGuardar.value) {
    const result = await confirmModal({
      vm: proxy,
      title: "Cambios sin guardar.",
      text: "Posee cambios sin guardar.",
      icon: "warning",
      showCancelButton: true,
      showCloseButton: true,
      cancelButtonText: "Volver",
      confirmButtonText: "Guardar y volver",
    });

    if (result.isConfirmed) {
      guardarCambios();
    }
  }
  proxy.$router.push("/lista-competiciones");
}

// Modificar forzarRecalculoCurvas
async function forzarRecalculoCurvas() {
  if (calculandoCurvas.value) {
    console.log("⏸️ Ya se está forzando recálculo, omitiendo...");
    return;
  }

  console.log("🔄 Forzando recálculo de curvas...");

  // Limpiar primero
  curves.value = [];

  // Esperar a que Vue actualice
  await nextTick();
  await nextTick();

  // Pequeño delay para asegurar renderizado
  await new Promise((resolve) => setTimeout(resolve, 50));

  // Calcular
  calcularCurvas();
}

function cambiarEstado(estado: string) {
  estadoTorneo.value = estado;
}

onMounted(async () => {
  window.addEventListener("resize", forzarRecalculoCurvas);
  // Recalcular después de que todo esté montado
  setTimeout(forzarRecalculoCurvas, 100);

  const params = {
    idTorneo: proxy.$route.params.id,
  };

  const { data } = await axios.get("/Torneos/GetTorneoById", {
    params,
  });

  nombreTorneo.value = data.nombre;
  categoriaTorneo.value = data.categoria;
  generoTorneo.value = data.genero;
  tipoCompetenciaTorneo.value = data.tipoCompetencia;
  estadoTorneo.value = data.estado;
  idTorneo.value = data.idTorneo;
  idInstitucion.value = data.idInstitucion;
  deporte.value = data.deporte;

  infoTorneo.value = `${nombreTorneo.value} - Categoría: ${categoriaTorneo.value} - Género: ${generoTorneo.value}`;

  if (data.configuraciones) {
    const configuraciones = JSON.parse(data.configuraciones);

    console.log("configuraciones", configuraciones);
    torneo.value = { ...configuraciones };
    total.value = configuraciones.total;
    modalidad.value = configuraciones.formato;
    clasificados.value = configuraciones.totalClasificados;
    estrategiaByes.value = configuraciones.estrategiaByes;
    zonasDeseadas.value = configuraciones.zonasDeseadas;
    await nextTick();
  }

  guardarInterval.value = setInterval(() => {
    if (hayCambiosSinGuardar.value && estadoTorneo.value !== "Finalizado") {
      guardarCambios();
    }
  }, 30000);
});

onUnmounted(() => {
  clearInterval(guardarInterval.value);
  window.removeEventListener("resize", forzarRecalculoCurvas);
});

// function calcularTablaZona(zona: any) {
//   // returns array sorted by points, then set diff, then game diff
//   const mapa = new Map();
//   zona.equipos.forEach((eq: any) =>
//     mapa.set(eq.id, {
//       equipo: eq,
//       puntos: 0,
//       setsGanados: 0,
//       setsPerdidos: 0,
//       gamesGanados: 0,
//       gamesPerdidos: 0,
//       pj: 0,
//     }),
//   );

//   zona.partidos.forEach((p: any) => {
//     if (!p.sets || p.sets.length < 2) return;
//     const local = mapa.get(p.local.id);
//     const visitante = mapa.get(p.visitante.id);
//     local.pj++;
//     visitante.pj++;
//     let setsLocal = 0,
//       setsVisitante = 0;
//     p.sets.forEach((s: any) => {
//       if (
//         !Number.isInteger(s.gamesLocal) ||
//         !Number.isInteger(s.gamesVisitante)
//       )
//         return;
//       local.gamesGanados += s.gamesLocal;
//       local.gamesPerdidos += s.gamesVisitante;
//       visitante.gamesGanados += s.gamesVisitante;
//       visitante.gamesPerdidos += s.gamesLocal;
//       if (s.gamesLocal > s.gamesVisitante) {
//         setsLocal++;
//       } else if (s.gamesVisitante > s.gamesLocal) {
//         setsVisitante++;
//       }
//     });
//     local.setsGanados += setsLocal;
//     local.setsPerdidos += setsVisitante;
//     visitante.setsGanados += setsVisitante;
//     visitante.setsPerdidos += setsLocal;
//     if (setsLocal > setsVisitante) {
//       local.puntos += 3;
//     } else if (setsVisitante > setsLocal) {
//       visitante.puntos += 3;
//     } else {
//       local.puntos += 1;
//       visitante.puntos += 1;
//     }
//   });

//   const arr = Array.from(mapa.values());
//   arr.sort((a: any, b: any) => {
//     if (b.puntos !== a.puntos) return b.puntos - a.puntos;
//     const aSetDiff = a.setsGanados - a.setsPerdidos || 0;
//     const bSetDiff = b.setsGanados - b.setsPerdidos || 0;
//     if (bSetDiff !== aSetDiff) return bSetDiff - aSetDiff;
//     const aGameDiff = a.gamesGanados - a.gamesPerdidos || 0;
//     const bGameDiff = b.gamesGanados - b.gamesPerdidos || 0;
//     if (bGameDiff !== aGameDiff) return bGameDiff - aGameDiff;
//     return a.equipo.nombre.localeCompare(b.equipo.nombre);
//   });
//   return arr;
// }

// Agrega esta función al script
function hayResultadosEnFaseEliminacion() {
  if (!torneo.value?.rondas) return false;

  // Revisar todas las rondas de eliminación
  for (const ronda of torneo.value.rondas) {
    for (const partido of ronda.partidos) {
      // Verificar si hay resultado (excluyendo BYEs automáticos)
      if (partido.resultado && !partido.pasaAutomatico) {
        return true;
      }
      // O verificar si hay sets completados
      if (partido.sets && partido.sets.length > 0) {
        const setCompletado = partido.sets.some(
          (s: any) =>
            Number.isInteger(s.gamesLocal) &&
            Number.isInteger(s.gamesVisitante),
        );
        if (setCompletado) {
          return true;
        }
      }
    }
  }
  return false;
}

async function actualizarFaseEliminacion() {
  if (!torneo.value?.rondas || torneo.value.rondas.length === 0) return;

  try {
    // 1. Obtener PREDICCIÓN ORIGINAL desde utils con la estrategia correcta
    const estrategia = torneo.value.estrategiaByes || "orden_zonas";
    const prediccionOriginal = generarCrucesConByes(
      torneo.value.clasificadosPorZona,
      torneo.value.totalClasificados,
      estrategia, // Pasar la estrategia
    );

    // 2. Obtener clasificados REALES de las zonas
    const clasificados = obtenerClasificados();

    console.log("Clasificados obtenidos:", clasificados);
    console.log(
      "Mapa de predicciones guardado:",
      mapaPrediccionesEquipos.value.size,
    );

    // 3. Función para encontrar equipo por identificador - MODIFICADA para usar clasificados
    const crearEncontrarEquipo = (clasificadosArray: any[]) => {
      return (identificador: string) => {
        if (!identificador || typeof identificador !== "string") return null;

        console.log("Buscando equipo para identificador:", identificador);

        // PATRÓN 1: "Xº mejor de zona Y" (ej: "1º mejor de zona 1")
        const matchMejorDeZona = identificador.match(
          /(\d+)º mejor de zona (\d+)/,
        );
        if (matchMejorDeZona) {
          const nivel = parseInt(matchMejorDeZona[1]);
          const zona = parseInt(matchMejorDeZona[2]);

          console.log(`Buscando ${nivel}º mejor de zona ${zona}`);

          const equipo = clasificadosArray.find(
            (c) => c._meta && c._meta.zona === zona && c._meta.nivel === nivel,
          );

          if (equipo) {
            console.log(
              `Encontrado: ${equipo.nombre} (zona ${zona}, ${nivel}º)`,
            );
          }

          return equipo || null;
        }

        // PATRÓN 2: "Xº de zona Y" (ej: "1º de zona 1")
        const matchZona = identificador.match(/(\d+)º de zona (\d+)/);
        if (matchZona) {
          const nivel = parseInt(matchZona[1]);
          const zona = parseInt(matchZona[2]);

          console.log(`Buscando ${nivel}º de zona ${zona}`);

          const equipo = clasificadosArray.find(
            (c) => c._meta && c._meta.zona === zona && c._meta.nivel === nivel,
          );

          if (equipo) {
            console.log(`Encontrado: ${equipo.nombre}`);
          }

          return equipo || null;
        }

        // PATRÓN 3: "Xº mejor Yº" (ej: "1º mejor 2º" = el mejor entre los segundos)
        const matchMejorComplejo = identificador.match(/(\d+)º mejor (\d+)º/);
        if (matchMejorComplejo) {
          const posicion = parseInt(matchMejorComplejo[1]);
          const nivel = parseInt(matchMejorComplejo[2]);

          console.log(`Buscando ${posicion}º mejor entre los ${nivel}º`);

          const equiposDelNivel = clasificadosArray
            .filter((c) => c._meta && c._meta.nivel === nivel)
            .sort((a, b) => {
              if (b._meta.puntos !== a._meta.puntos)
                return b._meta.puntos - a._meta.puntos;
              if (b._meta.setsDiff !== a._meta.setsDiff)
                return b._meta.setsDiff - a._meta.setsDiff;
              return b._meta.gamesDiff - a._meta.gamesDiff;
            });

          console.log(`Equipos del nivel ${nivel}:`, equiposDelNivel.length);

          if (posicion - 1 < equiposDelNivel.length) {
            const equipo = equiposDelNivel[posicion - 1];
            console.log("Encontrado:", equipo?.nombre);
            return equipo;
          }

          return null;
        }

        // PATRÓN 4: "Mejor Xº" (ej: "Mejor 2º")
        const matchMejorSimple = identificador.match(/Mejor (\d+)º/);
        if (matchMejorSimple) {
          const nivel = parseInt(matchMejorSimple[1]);

          console.log(`Buscando Mejor ${nivel}º`);

          const equiposNivel = clasificadosArray
            .filter((c) => c._meta && c._meta.nivel === nivel)
            .sort((a, b) => {
              if (b._meta.puntos !== a._meta.puntos)
                return b._meta.puntos - a._meta.puntos;
              if (b._meta.setsDiff !== a._meta.setsDiff)
                return b._meta.setsDiff - a._meta.setsDiff;
              return b._meta.gamesDiff - a._meta.gamesDiff;
            });

          if (equiposNivel.length > 0) {
            const equipo = equiposNivel[0];
            console.log("Encontrado:", equipo?.nombre);
            return equipo;
          }

          return null;
        }

        // PATRÓN 5: Solo "Mejor" (sin número)
        if (identificador.includes("Mejor") && !identificador.match(/\d/)) {
          console.log('Buscando "Mejor" (sin especificar nivel)');

          const todosOrdenados = clasificadosArray.sort((a, b) => {
            if (b._meta.puntos !== a._meta.puntos)
              return b._meta.puntos - a._meta.puntos;
            if (b._meta.setsDiff !== a._meta.setsDiff)
              return b._meta.setsDiff - a._meta.setsDiff;
            return b._meta.gamesDiff - a._meta.gamesDiff;
          });

          if (todosOrdenados.length > 0) {
            console.log("Encontrado:", todosOrdenados[0]?.nombre);
            return todosOrdenados[0];
          }
        }

        console.warn(`Patrón no reconocido: "${identificador}"`);
        return null;
      };
    };

    const encontrarEquipo = crearEncontrarEquipo(clasificados);
    const ronda1 = torneo.value.rondas[0];

    if (partidosOriginalesRonda1.value.length === 0) {
      // Guardar dos versiones: predicciones y equipos
      const prediccionesOriginales = JSON.parse(
        JSON.stringify(ronda1.partidos),
      );
      const equiposOriginales = JSON.parse(JSON.stringify(ronda1.partidos));

      // Para las predicciones, mantener strings
      // Para equipos, convertir strings a null para futura asignación
      prediccionesOriginales.forEach((partido: any) => {
        // Esta es la versión con predicciones (strings)
      });

      equiposOriginales.forEach((partido: any) => {
        // Esta es la versión que solo tiene la estructura, sin equipos asignados
        partido.local = null;
        partido.visitante = null;
        partido.ganador = null;
        partido.resultado = "";
        partido.pasaAutomatico = false;
        const minimosRequeridos = deporte.value === "Futbol" ? 1 : 2;
        partido.sets = Array.from({ length: minimosRequeridos }, () => ({
          gamesLocal: null,
          gamesVisitante: null,
        }));
      });

      // Guardar ambas versiones
      partidosOriginalesPredicciones.value = prediccionesOriginales;
      partidosOriginalesEstructura.value = equiposOriginales;

      console.log("Partidos originales guardados en dos versiones");
    }

    // DECIDIR QUÉ ESTRATEGIA USAR
    // Importante: Usamos mapeo solo si hay predicciones guardadas
    if (mapaPrediccionesEquipos.value.size > 0) {
      console.log("Usando mapeo guardado de predicciones reorganizadas");
      await asignarEquiposConMapeo(ronda1, clasificados, encontrarEquipo);
    } else {
      console.log("Usando asignación original de predicciones");
      await asignarEquiposOriginal(
        ronda1,
        clasificados,
        prediccionOriginal,
        encontrarEquipo,
      );
    }

    await nextTick();
    calcularCurvas();
    partidoRefsReady.value = true;

    console.log("Fase de eliminación actualizada exitosamente");
  } catch (error) {
    console.error("Error en actualizarFaseEliminacion:", error);
    // Fallback a método simple
    await actualizarFaseEliminacionSimple();
  }
}

// Función de fallback simple
async function actualizarFaseEliminacionSimple() {
  const clasificados = obtenerClasificados();
  const ronda1 = torneo.value.rondas[0];
  const cuadroFinal = torneo.value.cuadroFinal;
  const totalClasificados = clasificados.length;

  const byes = cuadroFinal - totalClasificados;
  const mejoresConBye = clasificados.slice(0, byes);
  const restantes = clasificados.slice(byes);

  const participantes: any[] = [...mejoresConBye, ...restantes];
  while (participantes.length < cuadroFinal) {
    participantes.push(null);
  }

  ronda1.partidos.forEach((partido: any, idx: any) => {
    const local = participantes[idx];
    const visitante = participantes[cuadroFinal - 1 - idx];

    partido.local = local;
    partido.visitante = visitante;
    partido.pasaAutomatico = local === null || visitante === null;

    if (local && !visitante) {
      partido.ganador = local;
      partido.resultado = "BYE (avanza " + local.nombre + ")";
      actualizarSiguienteRonda(partido);
    } else if (!local && visitante) {
      partido.ganador = visitante;
      partido.resultado = "BYE (avanza " + visitante.nombre + ")";
      actualizarSiguienteRonda(partido);
    }
  });

  await nextTick();
  calcularCurvas();
  partidoRefsReady.value = true;
}

function actualizarSiguienteRonda(partido: any) {
  if (!torneo.value?.rondas || !partido.ganador) return;

  const rondaActual = torneo.value.rondas.find(
    (r: any) => r.numero === partido.ronda,
  );
  if (!rondaActual) return;

  const siguienteRonda = torneo.value.rondas.find(
    (r: any) => r.numero === partido.ronda + 1,
  );

  if (!siguienteRonda) {
    // Es la final
    campeonKey.value++;
    return;
  }

  // Encontrar índice del partido
  const indicePartido = rondaActual.partidos.findIndex(
    (p: any) => p.id === partido.id,
  );
  if (indicePartido === -1) return;

  // Calcular índice en la siguiente ronda
  const indicePartidoSiguiente = Math.floor(indicePartido / 2);
  const partidoSiguiente = siguienteRonda.partidos[indicePartidoSiguiente];

  if (!partidoSiguiente) return;

  // Guardar si tenía ganador antes
  const teniaGanadorAnterior = !!partidoSiguiente.ganador;

  // Determinar si viene como local o visitante
  const vieneComoLocal = indicePartido % 2 === 0;

  // Determinar lado del cuadro
  const totalPartidosRonda = rondaActual.partidos.length;
  const mitadPartidos = totalPartidosRonda / 2;
  const esLadoIzquierdo = indicePartido < mitadPartidos;

  if (vieneComoLocal) {
    partidoSiguiente.local = partido.ganador;
    console.log(
      `✓ ${partido.ganador.nombre} avanza como LOCAL a P${partidoSiguiente.id}`,
    );
  } else {
    partidoSiguiente.visitante = partido.ganador;
    console.log(
      `✓ ${partido.ganador.nombre} avanza como VISITANTE a P${partidoSiguiente.id}`,
    );
  }

  // ⭐ RESETEAR RESULTADO CON SETS SEGÚN DEPORTE
  if (partidoSiguiente.local && partidoSiguiente.visitante) {
    partidoSiguiente.ganador = null;
    partidoSiguiente.resultado = "";

    // ✅ CREAR SETS DINÁMICAMENTE
    const minimosRequeridos = deporte.value === "Futbol" ? 1 : 2;
    partidoSiguiente.sets = Array.from({ length: minimosRequeridos }, () => ({
      gamesLocal: null,
      gamesVisitante: null,
    }));

    console.log(`✓ P${partidoSiguiente.id} listo para cargar resultado`);
  }

  // SI EL PARTIDO YA TENÍA GANADOR, PROPAGAR EL CAMBIO HACIA ADELANTE
  if (teniaGanadorAnterior) {
    console.log(
      `⚠ P${partidoSiguiente.id} tenía ganador, propagando a rondas posteriores...`,
    );
    propagarCambioHaciaRondasPosteriores(
      partidoSiguiente,
      esLadoIzquierdo,
      vieneComoLocal,
    );
  }
}

function propagarCambioHaciaRondasPosteriores(
  partidoSiguiente: any,
  esLadoIzquierdo: boolean,
  vieneComoLocal: boolean,
) {
  if (!torneo.value?.rondas || !partidoSiguiente) return;

  const rondaActualIndex = partidoSiguiente.ronda - 1;

  // ⭐ IMPORTANTE: Empezar desde ronda N+2 (skip la ronda que ya actualizamos)
  for (let i = rondaActualIndex + 1; i < torneo.value.rondas.length; i++) {
    const rondaPosterior = torneo.value.rondas[i];
    const rondaAnterior = torneo.value.rondas[i - 1];

    // Encontrar el partido en la ronda anterior
    const indicePartidoAnterior = rondaAnterior.partidos.findIndex(
      (p: any) => p.id === partidoSiguiente.id,
    );

    if (indicePartidoAnterior === -1) {
      console.log(`⚠️ No se encontró partido anterior P${partidoSiguiente.id}`);
      break;
    }

    // Calcular índice en la ronda posterior
    const indicePartidoPosterior = Math.floor(indicePartidoAnterior / 2);
    const partidoPosterior = rondaPosterior.partidos[indicePartidoPosterior];

    if (!partidoPosterior) break;

    console.log(
      `📤 Procesando ronda posterior ${i + 1}: P${partidoPosterior.id}`,
    );

    // ⭐ DETERMINAR QUÉ LADO DE ESTE PARTIDO VIENE DE LA RAMA AFECTADA
    const esLocalEnRondaAnterior = indicePartidoAnterior % 2 === 0;

    // ⭐ RESETEAR RESULTADO SIEMPRE
    partidoPosterior.ganador = null;
    partidoPosterior.resultado = "";
    const minimosRequeridos = deporte.value === "Futbol" ? 1 : 2;
    partidoPosterior.sets = Array.from({ length: minimosRequeridos }, () => ({
      gamesLocal: null,
      gamesVisitante: null,
    }));

    // ⭐ CONVERTIR EL LADO AFECTADO EN PREDICCIÓN
    if (esLocalEnRondaAnterior) {
      // El LOCAL viene de la rama afectada
      partidoPosterior.local = { nombre: `Ganador P${partidoSiguiente.id}` };
      console.log(
        `✅ Convertido LOCAL a predicción: Ganador P${partidoSiguiente.id}`,
      );

      // ⭐ MANTENER EL VISITANTE (del otro lado) SIN CAMBIOS
      // Solo si no hay visitante, establecer predicción
      if (!partidoPosterior.visitante) {
        const indiceOponente = indicePartidoAnterior + 1;
        const partidoOponente = rondaAnterior.partidos[indiceOponente];

        if (partidoOponente) {
          partidoPosterior.visitante = {
            nombre: `Ganador P${partidoOponente.id}`,
          };
          console.log(
            `✓ Establecido VISITANTE (predicción): Ganador P${partidoOponente.id}`,
          );
        }
      } else {
        console.log(
          `✓ Mantenido VISITANTE: ${partidoPosterior.visitante.nombre || "—"}`,
        );
      }
    } else {
      // El VISITANTE viene de la rama afectada
      partidoPosterior.visitante = {
        nombre: `Ganador P${partidoSiguiente.id}`,
      };
      console.log(
        `✅ Convertido VISITANTE a predicción: Ganador P${partidoSiguiente.id}`,
      );

      // ⭐ MANTENER EL LOCAL (del otro lado) SIN CAMBIOS
      // Solo si no hay local, establecer predicción
      if (!partidoPosterior.local) {
        const indiceOponente = indicePartidoAnterior - 1;
        const partidoOponente = rondaAnterior.partidos[indiceOponente];

        if (partidoOponente) {
          partidoPosterior.local = { nombre: `Ganador P${partidoOponente.id}` };
          console.log(
            `✓ Establecido LOCAL (predicción): Ganador P${partidoOponente.id}`,
          );
        }
      } else {
        console.log(
          `✓ Mantenido LOCAL: ${partidoPosterior.local.nombre || "—"}`,
        );
      }
    }

    // Actualizar referencia para la siguiente iteración
    partidoSiguiente = partidoPosterior;
  }
}

function obtenerClasificados() {
  if (!torneo.value?.zonas) return [];

  const clasificados: any[] = [];

  // Para cada zona
  torneo.value.zonas.forEach((zona: any, zonaIndex: any) => {
    const tabla = calcularTablaZona(zona, deporte.value);
    const cantClasificados = torneo.value.clasificadosPorZona[zonaIndex] || 0;

    // Tomar los clasificados de esta zona
    for (let i = 0; i < Math.min(cantClasificados, tabla.length); i++) {
      const fila = tabla[i];
      clasificados.push({
        id: fila.equipo.id,
        nombre: fila.equipo.nombre,
        _meta: {
          zona: zona.id,
          nivel: i + 1, // 1º, 2º, 3º, etc. en la zona
          puntos: fila.puntos,
          setsGanados: fila.setsGanados,
          setsPerdidos: fila.setsPerdidos,
          gamesGanados: fila.gamesGanados,
          gamesPerdidos: fila.gamesPerdidos,
          setsDiff: fila.setsGanados - fila.setsPerdidos,
          gamesDiff: fila.gamesGanados - fila.gamesPerdidos,
          pj: fila.pj,
        },
      });
    }
  });

  return clasificados;
}

function obtenerNombreRonda(numeroRonda: number, totalRondas: number): string {
  const rondasDesdeElFinal = totalRondas - numeroRonda + 1;

  if (rondasDesdeElFinal === 1) return "Final";
  if (rondasDesdeElFinal === 2) return "Semifinal";
  if (rondasDesdeElFinal === 3) return "Cuartos de Final";
  if (rondasDesdeElFinal === 4) return "Octavos de Final";

  // Para rondas anteriores, usar potencias de 2
  const equiposEnRonda = Math.pow(2, rondasDesdeElFinal);
  return `Ronda de ${equiposEnRonda}`;
}

// Función para abrir modal
async function abrirModalFinalizar() {
  const validacion = puedeFinalizarTorneo(torneo.value);

  if (!validacion.puede) {
    showAlert({
      icon: "warning",
      title: "No se puede finalizar",
      text: validacion.razon,
      timer: 4000,
      vm: proxy,
    });
    return;
  }

  jugadoresFinales.value = obtenerJugadoresOrdenadosTorneo(
    torneo.value,
    nombreTorneo.value,
    categoriaTorneo.value,
    generoTorneo.value,
  );

  if (jugadoresFinales.value.length === 0) {
    showAlert({
      icon: "warning",
      title: "Sin jugadores asignados",
      text: "No hay jugadores con asignación válida en este torneo.",
      timer: 4000,
      vm: proxy,
    });
    const datosTorneo = {
      nombre: "",
      descripcion: "",
      genero: null,
      categoria: null,
      fecha: "01/01/2025",
      tipoCompetencia: null,
      estado: "Finalizado",
      configuraciones: "",
      idTorneo: idTorneo.value,
      idInstitucion: proxy.$store.state.usuario.institucion.idInstitucion,
    };

    await axios.post("/Torneos/CambiarEstado", datosTorneo);

    await guardarCambios();

    cambiarEstado("Finalizado");
    return;
  }

  modalFinalizarVisible.value = true;
}

// Función para finalizar
async function finalizarTorneo(jugadores: JugadorParaFinalizar[]) {
  try {
    const payload = {
      idTorneo: idTorneo.value,
      jugadores: JSON.stringify(
        jugadores.map((j) => ({
          idJugador: j.idJugador,
          nombreJugador: j.nombreJugador,
          posicion: j.ordenMerito,
          puntosAsignados: j.puntosAsignados,
        })),
      ),
      idInstitucion: proxy.$store.state.usuario.institucion.idInstitucion,
    };

    await axios.post("/Ranking/GuardarRanking", payload);

    const datosTorneo = {
      nombre: "",
      descripcion: "",
      genero: null,
      categoria: null,
      fecha: "01/01/2025",
      tipoCompetencia: null,
      estado: "Finalizado",
      configuraciones: "",
      idTorneo: idTorneo.value,
      idInstitucion: proxy.$store.state.usuario.institucion.idInstitucion,
    };

    await axios.post("/Torneos/CambiarEstado", datosTorneo);

    await guardarCambios();

    cambiarEstado("Finalizado");

    modalFinalizarVisible.value = false;

    showAlert({
      icon: "success",
      title: "¡Torneo Finalizado!",
      text: "Los puntos han sido asignados correctamente.",
      timer: 3000,
      vm: proxy,
    });
  } catch (error) {
    showAlert({
      icon: "error",
      title: "Error",
      text: "No se pudo finalizar el torneo.",
      timer: 4000,
      vm: proxy,
    });
  }
}

watch(
  () => {
    if (!torneo.value?.zonas) return null;

    // Crear una firma única solo de las zonas
    return torneo.value.zonas
      .map((zona: any) =>
        zona.partidos
          .map(
            (partido: any) =>
              partido.sets
                ?.map(
                  (set: any) =>
                    `${set.gamesLocal || "null"}-${
                      set.gamesVisitante || "null"
                    }`,
                )
                .join("|") || "empty",
          )
          .join(";"),
      )
      .join("||");
  },
  () => {
    if (todosResultadosZonas.value) {
      console.log(
        "✅ Todas las zonas completas, ejecutando actualizarFaseEliminacion",
      );
      actualizarFaseEliminacion();
    }
  },
  { deep: false }, // IMPORTANTE: deep: false porque ya manejamos la reactividad
);

watch(
  () => tab.value,
  (newTab, oldTab) => {
    if (newTab === 2 && torneo.value) {
      console.log(
        `📊 Cambiando a pestaña eliminación (modalidad: ${modalidad.value})`,
      );

      // Limpiar timeout anterior
      clearTimeout(timeoutCalculoCurvas);

      // Delay diferente según modalidad
      const delay = modalidad.value === "eliminacion_directa" ? 100 : 50;

      timeoutCalculoCurvas = setTimeout(() => {
        // Marcar refs como listos
        partidoRefsReady.value = true;

        // Forzar cálculo
        if (!calculandoCurvas.value) {
          forzarRecalculoCurvas();
        }
      }, delay);
    }
  },
);

let timeoutCalculoCurvas: any = null;

watch(
  () => todosResultadosZonas.value,
  (todosCompletos) => {
    if (todosCompletos && tab.value === 2) {
      // Cuando se completan todas las zonas y estamos en fase eliminación
      nextTick(() => {
        setTimeout(() => {
          forzarRecalculoCurvas();
        }, 50);
      });
    }
  },
);

// Watcher profundo
watch(
  () => torneo.value,
  (nuevoTorneo, viejoTorneo) => {
    if (!torneoOriginal.value) {
      // Guardar copia inicial
      torneoOriginal.value = JSON.parse(JSON.stringify(nuevoTorneo));
      hayCambiosSinGuardar.value = false;
      return;
    }

    // Comparar con la copia original
    const haCambiado =
      JSON.stringify(nuevoTorneo) !== JSON.stringify(torneoOriginal.value);
    hayCambiosSinGuardar.value = haCambiado;

    console.log("¿Torneo modificado?", haCambiado);
  },
  { deep: true, immediate: true },
);

// Función para resetear el estado de modificación
async function guardarCambios() {
  if (torneo.value) {
    torneoOriginal.value = JSON.parse(JSON.stringify(torneo.value));
    hayCambiosSinGuardar.value = false;
    console.log("Torneo marcado como guardado");

    const torneoGuardar = {
      idTorneo: proxy.$route.params.id,
      configuraciones: JSON.stringify(torneo.value),
      idInstitucion: proxy.$route.params.idInstitucion,
    };

    const response = await axios.post(
      "/Torneos/ModificarConfiguraciones",
      torneoGuardar,
    );

    console.log("response", response);
  }
}

return { __sfc: true,total, modalidad, clasificados, zonasDeseadas, estrategiaByes, nombreTorneo, categoriaTorneo, generoTorneo, tipoCompetenciaTorneo, idTorneo, idInstitucion, infoTorneo, deporte, torneo, torneoOriginal, partidoRefs, partidoRefsReady, curves, ignoreNextZonaChange, tab, zonaTabs, zonaDragOver, equipoDragging, partidoDragging, posicionDragging, partidosOriginalesRonda1, partidosOriginalesPredicciones, partidosOriginalesEstructura, modalResultadoVisible, modalAsignarJugadoresVisible, modalAsignarNombreVisible, partidoActivo, equipoActivo, zonaActiva, sets, modalDetallesVisible, rondasContainer, svgWidth, svgHeight, calculandoCurvas, ultimoCalculo, guardarInterval, habilitarEdicionPredicciones, modalidades, estrategiasByes, campeonKey, estadoKey, equipoDragData, estadoTorneo, hayCambiosSinGuardar, modalFinalizarVisible, jugadoresFinales, proxy, configDeporte, usaJugadores, headersPartidos, prediccionDragging, mapaPrediccionesEquipos, abrirModalDetalles, closeModalDetalles, guardarDetalles, reestablecerPrediccionesRondasSiguientes, limpiarFlagsTemporales, moverEquipoEntreZonas, regenerarPartidosDeZona, onPrediccionDragStart, onPrediccionDragOver, onPrediccionDrop, intercambiarPredicciones, actualizarByesDespuesIntercambio, resetPrediccionDrag, guardarMapeoPredicciones, asignarEquiposConMapeo, buscarEquipoEnClasificados, asignarEquiposOriginal, onEquipoDragStart, onEquipoDragStartZona, onZonaDragOver, onZonaDragLeave, onZonaDrop, limpiarFeedbackDrag, onEquipoDragEnd, onEquipoDragOver, onEquipoDragLeave, onEquipoDrop, intercambiarEquipos, toggleEdicionPredicciones, resetearYReasignarRefs, recalcularTodasLasConexiones, limpiarResultadoPartido, resetDragData, obtenerPosicionEquipo, resetearCruces, todosResultadosZonas, algunResultadoZona, campeon, abrirModalResultadoConAdvertencia, esObjetoEquipo, obtenerNombreEquipo, abrirModalResultado, verificarSiAfectaRondasPosteriores, closeModalResultado, esEquipoTemporal, resetearRamaDesdePartido, guardarResultado, editarNombreEquipoEliminacion, editarNombreEquipo, editarNombreEquipoFutbol, asignarNombreEquipoFutbol, asignarJugadoresAEquipoActivo, resetearJugadoresEquipo, confirmaFinalizacionTorneo, resetearJugadoresEquipoEliminacion, obtenerIdsJugadoresUsados, actualizarNombreEquipoEnObjeto, eliminarEquipo, limpiarRefsPartidos, generarTorneoClick, agregarEquipo, calcularCurvas, volver, forzarRecalculoCurvas, cambiarEstado, hayResultadosEnFaseEliminacion, actualizarFaseEliminacion, actualizarFaseEliminacionSimple, actualizarSiguienteRonda, propagarCambioHaciaRondasPosteriores, obtenerClasificados, obtenerNombreRonda, abrirModalFinalizar, finalizarTorneo, timeoutCalculoCurvas, guardarCambios, calcularTablaZona, CargarResultado, EditarDetallesPartido, TorneoContextBar, AsignarJugadores, AsignarNombreEquipo, ModalFinalizarCompetencia }
}

})